import React from "react";
import theme from "theme";
import { Theme, Box, Image, LinkBox, Text, Link, Structure, Section, Span, Strong, Hr, List, Em, Icon } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
import { FaTelegram } from "react-icons/fa";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"index"} />
		<Helmet>
			<title>
				Конструктор интернет-магазина в Телеграм - Веб-бот uShopWebBot
			</title>
			<meta name={"description"} content={"uShopWebBot - Конструктор интернет-магазина в Телеграм в формате Web Бота"} />
			<meta property={"og:title"} content={"Конструктор интернет-магазина в Телеграм - Веб-бот uShopWebBot"} />
			<meta property={"og:description"} content={"uShopWebBot - Конструктор интернет-магазина в Телеграм в формате Web Бота"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/1.jpg?v=2022-12-25T20:50:47.139Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileColor"} content={"#000000"} />
		</Helmet>
		<Section
			padding="0px 0 0px 0"
			quarkly-title="MainBlock"
			background="--background"
			position="relative"
			overflow-y="hidden"
			overflow-x="hidden"
		>
			<Override slot="SectionContent" max-width="none" width="100%" />
			<Box
				quarkly-title="Shape1"
				background="rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/62ab65c921e43d0020961286/images/shape%202.png?v=2022-07-18T14:36:00.643Z) 50% 50% /100% repeat scroll padding-box"
				width="100%"
				height="100%"
				position="absolute"
			/>
			<Box
				quarkly-title="Shape2"
				background="rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/62ab65c921e43d0020961286/images/shape%203.png?v=2022-07-18T14:37:13.478Z) 0% 0% /cover repeat scroll padding-box"
				width="100%"
				height="100%"
				position="absolute"
				right="auto"
				bottom="0px"
				left="0px"
				top="auto"
			/>
			<Structure
				cells-number-total="2"
				quarkly-title="Navbar"
				position="relative"
				z-index="3"
				nout-z-index="9"
				padding="24px 0px 24px 0px"
			>
				<Override
					slot="Content"
					grid-template-columns="5fr 3fr"
					nout-grid-template-columns="3fr 3fr"
					lg-grid-template-columns="1fr 2fr"
					md-grid-template-columns="1fr 2fr"
					sm-grid-template-columns="1fr"
				>
					<Override slot="cell-0">
						<LinkBox href="https://www.ucoz.ru/bot/" pointer-events="none">
							<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z" display="block" />
						</LinkBox>
						<LinkBox flex-direction="row" href="/en" display="none" sm-display="flex">
							<Text
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								English
							</Text>
						</LinkBox>
						<Components.QuarklycommunityKitMobileSidePanel menuPosition="right" breakpoint="nout">
							<Override
								slot="Content"
								background="rgba(255, 255, 255, 0)"
								md-background="--background"
								padding="8px 16px 8px 16px"
								nout-z-index="9999"
								nout-background="--background"
							/>
							<Override slot="Button Icon" size="32px" />
							<Override
								slot="Button Text"
								nout-text-transform="uppercase"
								nout-font="normal 500 16px/200% &quot;Montserrat&quot;, sans-serif"
								nout-letter-spacing="1px"
								sm-display="flex"
								sm-align-items="center"
								sm-justify-content="center"
							>
								меню
							</Override>
							<Override slot="Wrapper" nout-z-index="9" />
							<Box
								width="100%"
								display="flex"
								grid-gap="20px"
								md-flex-direction="column"
								nout-flex-direction="column"
								nout-margin="20px 0px 0px 0px"
								nout-grid-gap="16px"
							>
								<Link
									href="https://www.ucoz.ru/bot/"
									color="--grey"
									font="--menu"
									text-decoration-line="initial"
									transition="--opacityOut"
									hover-opacity=".8"
									padding="5px 5px 5px 5px"
									pointer-events="none"
									user-select="none"
								>
									Магазин в Телеграм
								</Link>
								<Link
									href="#easy"
									color="#000000"
									text-decoration-line="initial"
									font="--menu"
									transition="--opacityOut"
									hover-opacity=".8"
									padding="5px 5px 5px 5px"
								>
									Возможности
								</Link>
								<Link
									href="#top"
									color="#000000"
									text-decoration-line="initial"
									font="--menu"
									transition="--opacityOut"
									hover-opacity=".8"
									padding="5px 5px 5px 5px"
								>
									Преимущества
								</Link>
								<Link
									href="#price"
									color="#000000"
									text-decoration-line="initial"
									font="--menu"
									transition="--opacityOut"
									hover-opacity=".8"
									padding="5px 5px 5px 5px"
								>
									Цены
								</Link>
								<Link
									href="#example"
									color="#000000"
									text-decoration-line="initial"
									font="--menu"
									transition="--opacityOut"
									hover-opacity=".8"
									padding="5px 5px 5px 5px"
								>
									Примеры
								</Link>
								<Link
									href="/bot/#faq"
									color="#000000"
									text-decoration-line="initial"
									font="--menu"
									transition="--opacityOut"
									hover-opacity=".8"
									padding="5px 5px 5px 5px"
								>
									FAQ
								</Link>
							</Box>
							<Box
								display="none"
								sm-display="flex"
								sm-flex-direction="column"
								sm-align-items="flex-start"
								sm-grid-gap="16px"
								sm-margin="16px 0px 0px 0px"
							>
								<Link
									href="/instrukciya"
									color="#000000"
									text-decoration-line="initial"
									font="--menu"
									transition="--opacityOut"
									hover-opacity=".8"
									sm-padding="5px 5px 5px 5px"
									sm-font="normal 700 14px/1.5 &quot;Montserrat&quot;, sans-serif"
								>
									Инструкция
								</Link>
								<Link
									href="https://t.me/uShopWebBot"
									color="--white"
									font="--button"
									text-decoration-line="initial"
									padding="12px 24px 12px 24px"
									background="--dark"
									border-radius="50px"
									transition="--opacityOut"
									hover-opacity=".8"
									target="_blank"
									md-padding="12px 20px 12px 20px"
									sm-align-self="center"
									sm-margin="20px 0px 0px 0px"
								>
									Создать веб-бота
								</Link>
							</Box>
						</Components.QuarklycommunityKitMobileSidePanel>
					</Override>
					<Override
						slot="Cell 0th"
						align-items="center"
						justify-content="flex-end"
						grid-gap="24px"
						display="flex"
						md-display="flex"
						md-grid-gap="16px"
						sm-align-items="center"
					/>
					<Override slot="cell-1">
						<Box
							min-width="100px"
							min-height="100px"
							align-items="center"
							justify-content="center"
							display="flex"
						>
							<Text
								color="--grey"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
								padding="5px 5px 5px 5px"
							>
								Ru
							</Text>
							<Link
								href="https://www.ucoz.com/bot/"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".6"
								padding="5px 5px 5px 5px"
							>
								En
							</Link>
						</Box>
						<Link
							href="/bot/instrukciya/"
							color="#000000"
							text-decoration-line="initial"
							font="--menu"
							transition="--opacityOut"
							hover-opacity=".8"
							padding="5px 5px 5px 5px"
						>
							Инструкция
						</Link>
						<Components.ButtonBot />
					</Override>
					<Override slot="Cell 1" sm-display="none" />
				</Override>
			</Structure>
			<Section
				align-items="center"
				quarkly-title="HeroBlock"
				padding="30px 0 00px 0"
				min-height="720px"
				position="relative"
				z-index="3"
				lg-padding="30px 0 0px 0"
				md-padding="5px 0 0px 0"
				sm-min-height="675px"
			>
				<Override
					slot="SectionContent"
					flex-direction="row"
					flex-wrap="wrap"
					position="relative"
					z-index="9"
					nout-z-index="4"
					sm-flex-direction="column"
					sm-justify-content="space-between"
					sm-height="100%"
					sm-padding="60px 0px 0px 0px"
				/>
				<Box
					min-width="100px"
					min-height="100px"
					width="55%"
					align-self="center"
					lg-width="100%"
					lg-margin="0px 0px 30px 0px"
					margin="-50px 0px 30px 0px"
				>
					<Text
						margin="0px 0px 24px 0px"
						color="--darkL1"
						font="--headline1"
						md-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
						md-text-align="center"
						sm-font="normal 800 23px/1.3 &quot;Montserrat&quot;, sans-serif"
						as="h1"
					>
						Конструктор интернет-магазина в формате веб-бота в Telegram
					</Text>
					<Text
						margin="0px 0px 40px 0px"
						color="--dark"
						font="--headline3"
						md-text-align="center"
						sm-font="normal 500 16px/24px &quot;Montserrat&quot;, sans-serif"
					>
						Не путайте с обычными чат-ботами в Телеграм, веб-бот это мини-приложение с более обширным функционалом, удобным интерфейсом и с подключенной онлайн оплатой.
					</Text>
					<Box
						display="flex"
						grid-gap="36px"
						nout-grid-gap="8px"
						sm-flex-direction="row"
						sm-text-align="center"
						grid-template-columns="1fr 1fr 1fr"
						sm-align-items="center"
						sm-justify-content="center"
						md-align-items="center"
						md-justify-content="center"
						sm-flex-wrap="wrap"
						sm-display="flex"
						sm-grid-gap="12px"
					>
						<Components.ButtonBot
							background="--primary"
							padding="16px 24px 16px 24px"
							hover-background="--dark"
							sm-width="100%"
							sm-padding="19px 24px 19px 24px"
						>
							Создать веб-бота бесплатно
						</Components.ButtonBot>
						<Link
							href="https://t.me/Dolce_Bot"
							color="--primary"
							font="--button"
							text-decoration-line="initial"
							padding="16px 24px 16px 24px"
							background="--white"
							border-radius="50px"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--white"
							hover-background="--primary"
							nout-padding="12px 16px 12px 16px"
							nout-display="flex"
							nout-align-items="center"
							sm-justify-content="center"
							sm-padding="16px 16px 16px 16px"
							align-self="center"
							justify-self="center"
							target="_blank"
							sm-width="80%"
						>
							Пример магазина
						</Link>
						<Components.PopDemo>
							<Override
								slot="button"
								display="flex"
								align-items="center"
								border-radius="50px"
								padding="0px 0px 0px 0px"
								hover-opacity="1"
								opacity=".9"
								transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
								width="53px"
								height="53px"
								justify-content="center"
								background="--white"
								color="--primary"
								hover-color="--dark"
							/>
							<Override slot="iconplay" margin="0px 0px 0px 0px" />
							<Override slot="wrapper" background="--background" md-width="95%" z-index="99999" />
							<Override
								slot="close"
								color="--dark"
								size="52px"
								transition="--transformOut"
								hover-transform="rotate(90deg)"
								z-index="110"
							/>
							<Override slot="content" z-index="107" />
							<Override slot="wrapper-close" z-index="0" display="none" />
							<Override slot="popup" z-index="9" />
							<Text
								margin="-20px 50px 20px 30px"
								font="--headline1"
								nout-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
								md-font="normal 800 16px/1.4 &quot;Montserrat&quot;, sans-serif"
								sm-margin="-30px 50px 10px 10px"
							>
								Демонстрация платформы
							</Text>
							<Components.QuarklycommunityKitVideo
								src="https://ukit.top/360/shopTelegram.mp4"
								muted
								playOnHover={false}
								position="relative"
								z-index="999999"
							>
								<Override slot="Video Tag" position="relative" z-index="9" />
							</Components.QuarklycommunityKitVideo>
						</Components.PopDemo>
					</Box>
				</Box>
				<Box
					min-width="100px"
					min-height="100px"
					width="45%"
					lg-width="100%"
					md-display="none"
					sm-display="flex"
					sm-height="176px"
					sm-flex-direction="row-reverse"
				>
					<Box
						border-radius="8px"
						md-height="100%"
						width="848px"
						md-max-width="265px"
						padding="0px 0px 0px 0px"
						margin="0px 0px 0px 0px"
						position="relative"
						z-index="8"
						lg-width="100%"
						md-max-height="175px"
						background="url(https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucozbotru%20%281%29.png?v=2025-02-21T17:48:10.519Z) 50% 0%/100% no-repeat scroll padding-box"
						height="720px"
						nout-z-index="3"
						sm-right="0px"
						sm-left="auto"
						sm-max-width="350px"
					/>
				</Box>
			</Section>
			<Box
				min-width="100px"
				min-height="100px"
				bottom="-97px"
				z-index="1"
				width="100%"
				quarkly-title="TextBottom"
				position="absolute"
				lg-bottom="0px"
				sm-bottom="-50px"
				sm-display="none"
			>
				<Components.QuarklycommunityKitMarquee pauseOnClick={false} pauseOnHover={false}>
					<Override slot="Container" lg-height="150px" />
					<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/text%20bottom.svg?v=2022-07-18T14:03:04.661Z" display="block" height="265px" sm-height="150px" />
				</Components.QuarklycommunityKitMarquee>
			</Box>
		</Section>
		<Structure
			id="webbot"
			padding="125px 0px 125px 0px"
			cells-number-total="4"
			quarkly-title="WebBot"
			nout-padding="60px 0px 60px 0px"
			position="relative"
		>
			<Override
				slot="Content"
				grid-template-columns="repeat(3, 1fr)"
				grid-gap="24px"
				nout-grid-template-columns="1fr"
				sm-overflow-x="hidden"
				sm-overflow-y="hidden"
				nout-display="flex"
				nout-flex-direction="column"
			>
				<Override slot="Cell 0th" />
				<Override slot="Cell 0" grid-column="1 /span 3" nout-grid-column="auto / auto" />
				<Override slot="cell-0">
					<Text
						margin="0px 0px 24px 0px"
						color="--darkL1"
						font="--headline1"
						lg-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
						md-font="normal 800 26px/1.4 &quot;Montserrat&quot;, sans-serif"
						md-text-align="center"
						sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
					>
						<Span
							color="--primary"
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Наш Веб–бот — это мини–приложение
							<br />
						</Span>
						в Telegram для продажи товаров
					</Text>
				</Override>
				<Override slot="cell-1">
					<Box
						min-height="541px"
						background="--dark"
						border-radius="32px"
						padding="40px 20px 0px 20px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						lg-width="100%"
					>
						<Box>
							<Text color="--white" font="--headline2" margin="0px 20px 16px 20px" md-text-align="center">
								Любые товары
							</Text>
							<Text color="--white" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
								Возможность продажи цифровых, физических товаров, а также услуг.
							</Text>
						</Box>
						<Image
							src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black.png?v=2022-08-25T10:44:37.118Z"
							display="block"
							width="100%"
							max-height="352px"
							srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black.png?v=2022-08-25T10%3A44%3A37.118Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black.png?v=2022-08-25T10%3A44%3A37.118Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black.png?v=2022-08-25T10%3A44%3A37.118Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black.png?v=2022-08-25T10%3A44%3A37.118Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black.png?v=2022-08-25T10%3A44%3A37.118Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black.png?v=2022-08-25T10%3A44%3A37.118Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black.png?v=2022-08-25T10%3A44%3A37.118Z&quality=85&w=3200 3200w"
							sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
						/>
					</Box>
				</Override>
				<Override slot="cell-2">
					<Box
						min-height="541px"
						border-radius="32px"
						background="--dark"
						padding="40px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						lg-width="100%"
					>
						<Text color="--white" font="--headline2" margin="0px 40px 16px 40px" md-text-align="center">
							Опции товаров
						</Text>
						<Text color="--white" font="--base" margin="0px 40px 40px 40px" md-text-align="center">
							Добавление параметров товара: цвет, размер и т.д.
						</Text>
						<Image
							src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Frame%20427320740.png?v=2022-08-25T10:44:59.057Z"
							display="block"
							width="100%"
							max-height="352px"
							object-position="0%"
							srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Frame%20427320740.png?v=2022-08-25T10%3A44%3A59.057Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Frame%20427320740.png?v=2022-08-25T10%3A44%3A59.057Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Frame%20427320740.png?v=2022-08-25T10%3A44%3A59.057Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Frame%20427320740.png?v=2022-08-25T10%3A44%3A59.057Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Frame%20427320740.png?v=2022-08-25T10%3A44%3A59.057Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Frame%20427320740.png?v=2022-08-25T10%3A44%3A59.057Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Frame%20427320740.png?v=2022-08-25T10%3A44%3A59.057Z&quality=85&w=3200 3200w"
							sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
						/>
					</Box>
				</Override>
				<Override slot="cell-3">
					<Box
						min-height="541px"
						border-radius="32px"
						background="--dark"
						padding="40px 0px 40px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						position="relative"
						z-index="1"
						lg-width="100%"
						sm-width="100%"
					>
						<Text color="--white" font="--headline2" margin="0px 40px 16px 40px" md-text-align="center">
							Оплата в боте
						</Text>
						<Text color="--white" font="--base" margin="0px 40px 55px 40px" md-text-align="center">
							Большой выбор платежных систем, в том числе и встроенных с Телеграм
						</Text>
						<Components.QuarklycommunityKitMarquee
							grid-gap="8px"
							max-width="410px"
							sm-max-width="350px"
							md-max-width="640px"
							lg-max-width="940px"
							nout-max-width="1000px"
							pauseOnHover
						>
							<Override slot="Container" />
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-ushop-12.svg?v=2022-07-20T11:39:16.036Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-ushop-13.svg?v=2022-07-20T11:39:16.036Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-ushop-01.svg?v=2022-07-20T11:39:16.019Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-card-02.svg?v=2022-07-20T11:39:16.021Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-telefram-08.svg?v=2022-07-20T11:39:16.032Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-ushop-09.svg?v=2022-07-20T11:39:16.031Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-telefram-07.svg?v=2022-07-20T11:39:16.024Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-ushop-04.svg?v=2022-07-20T11:39:16.022Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
						</Components.QuarklycommunityKitMarquee>
						<Components.QuarklycommunityKitMarquee
							grid-gap="8px"
							direction="right"
							max-width="410px"
							sm-max-width="350px"
							md-max-width="640px"
							lg-max-width="940px"
							nout-max-width="1000px"
							pauseOnHover
						>
							<Override slot="Container" />
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-ushop-10.svg?v=2022-07-20T11:39:16.032Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-card-03.svg?v=2022-07-20T11:39:16.028Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-telefram-03.svg?v=2022-07-20T11:39:16.018Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-telefram-04.svg?v=2022-07-20T11:39:16.017Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-telefram-06.svg?v=2022-07-20T11:39:16.026Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-telefram-02.svg?v=2022-07-20T11:39:16.016Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-ushop-02.svg?v=2022-07-20T11:39:16.031Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-ushop-11.svg?v=2022-07-20T11:39:16.034Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
						</Components.QuarklycommunityKitMarquee>
						<Components.QuarklycommunityKitMarquee
							grid-gap="8px"
							direction="left"
							max-width="410px"
							sm-max-width="350px"
							md-max-width="640px"
							lg-max-width="940px"
							nout-max-width="1000px"
							pauseOnHover
						>
							<Override slot="Container" />
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-card-01.svg?v=2022-07-20T11:39:16.021Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-ushop-06.svg?v=2022-07-20T11:39:16.025Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-ushop-07.svg?v=2022-07-20T11:39:16.031Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-ushop-03.svg?v=2022-07-20T11:39:16.028Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-ushop-05.svg?v=2022-07-20T11:39:16.025Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-ushop-08.svg?v=2022-07-20T11:39:16.030Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-telefram-01.svg?v=2022-07-20T11:39:16.026Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Property%201=logo-telefram-05.svg?v=2022-07-20T11:39:16.028Z"
								display="block"
								max-height="86px"
								padding="0px 0px 0px 0px"
								margin="4px 4px 4px 4px"
							/>
						</Components.QuarklycommunityKitMarquee>
					</Box>
				</Override>
				<Override slot="Cell 3" sm-display="flex" sm-align-items="center" sm-justify-content="center" />
			</Override>
		</Structure>
		<Section padding="0px 0 0px 0" quarkly-title="Video" position="relative">
			<Override
				slot="SectionContent"
				padding="195px 0px 195px 0px"
				background="linear-gradient(0deg,rgba(2, 2, 2, 0.18) 0%,rgba(2, 2, 2, 0.18) 99.5%),rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/62ab65c921e43d0020961286/images/background1111.webp?v=2025-02-21T22:06:45.362Z) 50% -200% /cover repeat scroll padding-box"
				border-radius="32px"
				justify-content="center"
				align-items="center"
				nout-padding="130px 0px 130px 0px"
				lg-padding="80px 0px 80px 0px"
			/>
			<Text
				margin="0px 0px 16px 0px"
				color="--white"
				opacity=".2"
				font="--headline1"
				hover-opacity="1"
				transition="--opacityOut"
				lg-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
				sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
				sm-text-align="center"
			>
				Как создать бот-магазин
			</Text>
			<Text
				margin="0px 0px 16px 0px"
				color="--white"
				font="--headline1"
				lg-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
				sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
				sm-text-align="center"
			>
				смотрите в видеоинструкции{" "}
			</Text>
			<Text
				margin="0px 0px 48px 0px"
				color="--white"
				font="--headline1"
				opacity=".2"
				hover-opacity="1"
				transition="--opacityOut"
				lg-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
				sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
				sm-text-align="center"
			>
				или читайте в базе знаний
			</Text>
			<Box
				display="flex"
				grid-gap="16px"
				align-items="center"
				width="100%"
				justify-content="center"
				md-flex-direction="column"
			>
				<Link
					href="/bot/instrukciya/"
					color="--white"
					font="--button"
					text-decoration-line="initial"
					padding="16px 24px 16px 24px"
					background="--primary"
					border-radius="50px"
					transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
					hover-color="--primary"
					hover-background="--white"
					target="_blank"
					min-width="220px"
					text-align="center"
					sm-width="80%"
				>
					Пошаговая инструкция
				</Link>
				<Link
					href="https://ubot.help/"
					color="--primary"
					font="--button"
					text-decoration-line="initial"
					padding="16px 24px 16px 24px"
					background="--white"
					border-radius="50px"
					transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
					hover-color="--white"
					hover-background="--primary"
					nout-align-items="center"
					sm-justify-content="center"
					sm-padding="16px 16px 16px 16px"
					align-self="center"
					justify-self="center"
					target="_blank"
					sm-width="80%"
					min-width="220px"
					text-align="center"
					md-text-align="center"
				>
					База знаний
				</Link>
			</Box>
		</Section>
		<Section
			id="easy"
			padding="125px 0 150px 0"
			quarkly-title="Tabs"
			nout-padding="60px 0 120px 0"
			position="relative"
			sm-padding="60px 0 60px 0"
		>
			<Text
				margin="0px 0px 0px 0px"
				color="--darkL1"
				font="--headline1"
				lg-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-font="normal 800 26px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
				as="h2"
			>
				<Span
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Создать Telegram магазин
				</Span>
				<br />
				легко, всего за 15 минут!
			</Text>
			<Text
				margin="0px 0px 24px 0px"
				color="--grey"
				font="--decsr"
				lg-font="normal 500 16px/180% &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
			>
				В среднем создание и настройка веб-бота в uShop занимает 15 минут.
			</Text>
			<Box
				display="flex"
				flex-direction="column"
				align-items="flex-start"
				margin="0px 0px 0px 0px"
				position="relative"
			>
				<Components.SimpleTabs
					defaultTab="1"
					flex-direction="column-reverse"
					width="100%"
					grid-gap="24px"
					display="flex"
					position="relative"
					lg-flex-direction="column"
				>
					<Override
						slot="Tablist"
						flex-direction="column"
						width="49%"
						position="absolute"
						right="0px"
						bottom="0px"
						lg-position="static"
						lg-width="100%"
					/>
					<Override
						slot="Tab"
						color="--grey"
						background="--white"
						font="--headline2"
						text-align="left"
						padding="16px 40px 16px 10px"
						focus-box-shadow="none"
						sm-font="normal 800 18px/130% &quot;Montserrat&quot;, sans-serif"
						sm-text-align="center"
					>
						Интеграция доставокИнтеграция доставок
					</Override>
					<Override slot="Tab 1" display="none">
						Интеграция доставок
					</Override>
					<Override slot="Tab 2">
						Управление товарами
					</Override>
					<Override slot="Tab 3">
						Статистика и отчеты
					</Override>
					<Override slot="Tab 4">
						Импорт и экспорт
					</Override>
					<Override slot="Tab :active" disabled={false} color="--primary" focus-box-shadow="none" />
					<Override slot="TabPanels" width="100%" />
					<Components.SimpleTab
						tabId="2"
						quarkly-title="Juice"
						grid-gap="24px"
						justify-content="flex-start"
						align-items="flex-start"
					>
						<Box
							min-width="100px"
							min-height="100px"
							grid-gap="48px"
							align-items="flex-start"
							md-flex-direction="column"
							display="flex"
							lg-flex-direction="column"
						>
							<Box
								box-shadow="0px 6px 10px rgba(0, 0, 0, 0.02)"
								background="--dark"
								border-radius="32px"
								width="45%"
								nout-overflow-y="hidden"
								nout-overflow-x="hidden"
								md-width="100%"
								padding="48px 0px 0px 48px"
								max-height="500px"
								overflow-x="hidden"
								overflow-y="hidden"
								border-width="2px"
								border-style="solid"
								border-color="#F5F6F8"
								height="576px"
								lg-width="100%"
								md-height="auto"
								sm-height="330px"
							>
								<Image
									src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/tovaradmin.png?v=2022-08-25T12:01:30.279Z"
									display="block"
									width="100%"
									position="relative"
									right="-1px"
									bottom="-1px"
									srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tovaradmin.png?v=2022-08-25T12%3A01%3A30.279Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tovaradmin.png?v=2022-08-25T12%3A01%3A30.279Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tovaradmin.png?v=2022-08-25T12%3A01%3A30.279Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tovaradmin.png?v=2022-08-25T12%3A01%3A30.279Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tovaradmin.png?v=2022-08-25T12%3A01%3A30.279Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tovaradmin.png?v=2022-08-25T12%3A01%3A30.279Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tovaradmin.png?v=2022-08-25T12%3A01%3A30.279Z&quality=85&w=3200 3200w"
									sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
								/>
							</Box>
							<Box
								box-shadow="0px 6px 10px rgba(0, 0, 0, 0.02)"
								background="--background"
								border-radius="32px"
								align-items="flex-start"
								display="flex"
								justify-content="flex-start"
								padding="40px 40px 40px 40px"
								width="50%"
								flex-direction="column"
								md-width="100%"
								sm-align-items="center"
								sm-padding="20px 20px 20px 20px"
								lg-width="100%"
							>
								<Text margin="0px 0px 16px 0px" font="--headline2" sm-text-align="center" sm-font="normal 800 24px/130% &quot;Montserrat&quot;, sans-serif">
									Управление товарами
								</Text>
								<Text margin="0px 0px 24px 0px" font="--base" sm-text-align="center">
									Обновляйте товары и принимайте заказы в веб-интерфейсе uShop, просматривайте остаток товаров и создавайте акции.{" "}
								</Text>
								<Link
									href="https://t.me/uShopWebBot?start=web"
									color="--white"
									font="--button"
									text-decoration-line="initial"
									padding="16px 24px 16px 24px"
									background="--primary"
									border-radius="50px"
									transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
									hover-color="--primary"
									hover-background="--white"
									target="_blank"
								>
									Создать магазин
								</Link>
							</Box>
						</Box>
					</Components.SimpleTab>
					<Components.SimpleTab tabId="1" quarkly-title="Fish">
						<Box
							min-width="100px"
							min-height="100px"
							display="flex"
							grid-gap="48px"
							align-items="flex-start"
							md-flex-direction="column"
							lg-flex-direction="column"
						>
							<Box
								width="45%"
								max-height="500px"
								lg-width="70%"
								lg-display="flex"
								sm-width="100%"
							>
								<Box
									box-shadow="0px 6px 10px rgba(0, 0, 0, 0.02)"
									border-radius="32px"
									width="100%"
									md-width="100%"
									padding="0px 0px 0px 0px"
									overflow-x="hidden"
									overflow-y="hidden"
									display="grid"
									md-height="auto"
									grid-template-columns="repeat(4, 1fr)"
									grid-gap="8px"
									align-content="start"
								>
									<Image
										src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/cdek.svg?v=2024-04-01T21:00:45.154Z"
										display="block"
										position="relative"
										right="-1px"
										bottom="-1px"
										width="100%"
									/>
									<Image
										src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/%D0%BF%D0%BE%D1%87%D1%82%D0%B0%20%D0%A0%D0%BE%D1%81%D1%81%D0%B8%D0%B8.svg?v=2024-04-01T21:04:26.281Z"
										display="block"
										position="relative"
										right="-1px"
										bottom="-1px"
										width="100%"
									/>
									<Image
										src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Yandex.svg?v=2024-04-01T21:04:36.163Z"
										display="block"
										position="relative"
										right="-1px"
										bottom="-1px"
										width="100%"
										grid-column="3 / 5"
									/>
									<Image
										src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Sber.svg?v=2024-04-01T21:05:36.395Z"
										display="block"
										position="relative"
										right="-1px"
										bottom="-1px"
										width="100%"
										grid-column="1 / 4"
									/>
									<Image
										src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/boxberry.svg?v=2024-04-01T21:06:27.081Z"
										display="block"
										position="relative"
										right="-1px"
										bottom="-1px"
										width="100%"
									/>
									<Image
										src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/%D1%83%D0%BA%D1%80%D0%BF%D0%BE%D1%88%D1%82%D0%B0.svg?v=2024-04-01T21:06:58.662Z"
										display="block"
										position="relative"
										right="-1px"
										bottom="-1px"
										width="100%"
									/>
									<Image
										src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Delline.svg?v=2024-04-01T21:07:10.830Z"
										display="block"
										position="relative"
										right="-1px"
										bottom="-1px"
										width="100%"
										grid-column="2 / 5"
									/>
									<Image
										src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/kaz.svg?v=2024-04-01T21:07:49.692Z"
										display="block"
										position="relative"
										right="-1px"
										bottom="-1px"
										width="100%"
									/>
									<Image
										src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ponyexpress.svg?v=2024-04-01T21:08:01.169Z"
										display="block"
										position="relative"
										right="-1px"
										bottom="-1px"
										width="100%"
									/>
									<Image
										src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Halva.svg?v=2024-04-01T21:08:07.878Z"
										display="block"
										position="relative"
										right="-1px"
										bottom="-1px"
										width="100%"
										grid-column="3 /5"
									/>
								</Box>
							</Box>
							<Box
								box-shadow="0px 6px 10px rgba(0, 0, 0, 0.02)"
								background="--background"
								border-radius="32px"
								align-items="flex-start"
								display="flex"
								justify-content="flex-start"
								padding="40px 40px 40px 40px"
								width="50%"
								flex-direction="column"
								md-width="100%"
								sm-align-items="center"
								sm-padding="20px 20px 20px 20px"
								lg-width="100%"
							>
								<Text margin="0px 0px 16px 0px" font="--headline2" sm-font="normal 800 24px/130% &quot;Montserrat&quot;, sans-serif" sm-text-align="center">
									Интеграция доставок
								</Text>
								<Text margin="0px 0px 24px 0px" font="--base" sm-text-align="center">
									Готовые интеграции с сервисами доставок (СДЕК, Почта России, Яндекс.Доставка, Нова пошта, Boxberry и многие другие), а также функционал подключения своих курьеров.
								</Text>
								<Link
									href="https://t.me/uShopWebBot"
									color="--white"
									font="--button"
									text-decoration-line="initial"
									padding="16px 24px 16px 24px"
									background="--primary"
									border-radius="50px"
									transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
									hover-color="--primary"
									hover-background="--white"
									target="_blank"
								>
									Создать магазин
								</Link>
							</Box>
						</Box>
					</Components.SimpleTab>
					<Components.SimpleTab tabId="3" quarkly-title="Meat">
						<Box
							min-width="100px"
							min-height="100px"
							display="flex"
							grid-gap="48px"
							align-items="flex-start"
							md-flex-direction="column"
							lg-flex-direction="column"
						>
							<Box
								box-shadow="0px 6px 10px rgba(0, 0, 0, 0.02)"
								background="--dark"
								border-radius="32px"
								width="45%"
								nout-overflow-y="hidden"
								nout-overflow-x="hidden"
								md-width="100%"
								padding="38px 0px 38px 48px"
								max-height="500px"
								overflow-x="hidden"
								overflow-y="hidden"
								border-width="2px"
								border-style="solid"
								border-color="#F5F6F8"
								justify-content="flex-end"
								display="flex"
								height="500px"
								lg-width="100%"
								md-height="auto"
								sm-height="330px"
							>
								<Image
									src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/stats.png?v=2022-08-25T12:16:01.916Z"
									display="block"
									position="relative"
									right="-1px"
									bottom="-1px"
									srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/stats.png?v=2022-08-25T12%3A16%3A01.916Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/stats.png?v=2022-08-25T12%3A16%3A01.916Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/stats.png?v=2022-08-25T12%3A16%3A01.916Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/stats.png?v=2022-08-25T12%3A16%3A01.916Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/stats.png?v=2022-08-25T12%3A16%3A01.916Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/stats.png?v=2022-08-25T12%3A16%3A01.916Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/stats.png?v=2022-08-25T12%3A16%3A01.916Z&quality=85&w=3200 3200w"
									sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
								/>
							</Box>
							<Box
								box-shadow="0px 6px 10px rgba(0, 0, 0, 0.02)"
								background="--background"
								border-radius="32px"
								align-items="flex-start"
								display="flex"
								justify-content="flex-start"
								padding="40px 40px 40px 40px"
								width="50%"
								flex-direction="column"
								md-width="100%"
								sm-align-items="center"
								sm-padding="20px 20px 20px 20px"
								lg-width="100%"
							>
								<Text margin="0px 0px 16px 0px" font="--headline2" sm-font="normal 800 24px/130% &quot;Montserrat&quot;, sans-serif" sm-text-align="center">
									Статистика и отчеты
								</Text>
								<Text margin="0px 0px 24px 0px" font="--base" sm-text-align="center">
									Собственная CRM система со всеми заказами и их статусами, уведомления которые будут приходить в Telegram боте. Просмотр статистики бота{" "}
								</Text>
								<Link
									href="https://t.me/uShopWebBot"
									color="--white"
									font="--button"
									text-decoration-line="initial"
									padding="16px 24px 16px 24px"
									background="--primary"
									border-radius="50px"
									transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
									hover-color="--primary"
									hover-background="--white"
									target="_blank"
								>
									Создать магазин
								</Link>
							</Box>
						</Box>
					</Components.SimpleTab>
					<Components.SimpleTab tabId="4" quarkly-title="Alcohol">
						<Box
							min-width="100px"
							min-height="100px"
							grid-gap="48px"
							align-items="flex-start"
							md-flex-direction="column"
							display="flex"
							lg-flex-direction="column"
						>
							<Box
								box-shadow="0px 6px 10px rgba(0, 0, 0, 0.02)"
								background="--dark"
								border-radius="32px"
								width="45%"
								nout-overflow-y="hidden"
								nout-overflow-x="hidden"
								md-width="100%"
								padding="48px 0px 0px 48px"
								max-height="500px"
								overflow-x="hidden"
								overflow-y="hidden"
								border-width="2px"
								border-style="solid"
								border-color="#F5F6F8"
								height="500px"
								lg-width="100%"
								md-height="auto"
								sm-height="330px"
							>
								<Image
									src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/export.png?v=2022-08-25T12:16:52.504Z"
									display="block"
									width="100%"
									position="relative"
									right="-1px"
									bottom="-1px"
									srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/export.png?v=2022-08-25T12%3A16%3A52.504Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/export.png?v=2022-08-25T12%3A16%3A52.504Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/export.png?v=2022-08-25T12%3A16%3A52.504Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/export.png?v=2022-08-25T12%3A16%3A52.504Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/export.png?v=2022-08-25T12%3A16%3A52.504Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/export.png?v=2022-08-25T12%3A16%3A52.504Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/export.png?v=2022-08-25T12%3A16%3A52.504Z&quality=85&w=3200 3200w"
									sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
								/>
							</Box>
							<Box
								box-shadow="0px 6px 10px rgba(0, 0, 0, 0.02)"
								background="--background"
								border-radius="32px"
								align-items="flex-start"
								display="flex"
								justify-content="flex-start"
								padding="40px 40px 40px 40px"
								width="50%"
								flex-direction="column"
								md-width="100%"
								sm-align-items="center"
								sm-padding="20px 20px 20px 20px"
								lg-width="100%"
							>
								<Text margin="0px 0px 16px 0px" font="--headline2" sm-text-align="center" sm-font="normal 800 24px/130% &quot;Montserrat&quot;, sans-serif">
									Импорт и экспорт
								</Text>
								<Text margin="0px 0px 24px 0px" font="--base" sm-text-align="center">
									Возможность импортировать ассортимент в uShop из 1С, Мой Склад, YML, Excel-таблиц или из интернет-магазина на любом другом движке
								</Text>
								<Link
									href="https://t.me/uShopWebBot"
									color="--white"
									font="--button"
									text-decoration-line="initial"
									padding="16px 24px 16px 24px"
									background="--primary"
									border-radius="50px"
									transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
									hover-color="--primary"
									hover-background="--white"
									target="_blank"
								>
									Создать магазин
								</Link>
							</Box>
						</Box>
					</Components.SimpleTab>
				</Components.SimpleTabs>
			</Box>
		</Section>
		<Section
			id="top"
			padding="125px 0 125px 0"
			background="--dark"
			quarkly-title="Card"
			position="relative"
			nout-padding="60px 0 60px 0"
		>
			<Override
				slot="SectionContent"
				display="flex"
				flex-direction="row"
				flex-wrap="wrap"
				position="static"
				z-index="1"
			/>
			<Box
				width="100%"
				height="100%"
				position="absolute"
				left="0px"
				top="0px"
				background="rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/62ab65c921e43d0020961286/images/bgcard.webp?v=2025-02-21T22:07:50.483Z) 0% 100% /auto no-repeat scroll padding-box"
			/>
			<Box
				min-width="100px"
				min-height="100px"
				width="100%"
				position="relative"
				z-index="1"
			>
				<Text
					margin="0px 0px 24px 0px"
					color="--white"
					font="--headline1"
					position="relative"
					lg-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
					md-font="normal 800 26px/1.4 &quot;Montserrat&quot;, sans-serif"
					md-text-align="center"
					sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
					as="h3"
				>
					Преимущества нашего конструктора
					<br />
					<Span
						color="--grey"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Веб-ботов Telegram
					</Span>
				</Text>
			</Box>
			<Box
				min-width="100px"
				min-height="100px"
				width="54%"
				padding="12px 12px 12px 12px"
				position="relative"
				z-index="1"
				nout-width="100%"
				sm-padding="12px 0px 12px 0px"
			>
				<Box
					background="--white"
					border-radius="32px"
					padding="52px 0px 0px 0px"
					display="flex"
					flex-direction="column"
					min-height="450px"
					overflow-x="hidden"
					overflow-y="hidden"
					sm-justify-content="space-between"
					sm-min-height="0px"
					transition="--transformOut"
					transform="translateY(0px)"
					hover-transform="translateY(-8px)"
				>
					<Text font="normal 800 32px/130% --fontFamily-googleMontserrat" margin="0px 52px 16px 52px" sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif" sm-margin="0px 25px 16px 25px">
						Высокая конверсия
					</Text>
					<Text font="--base" margin="0px 52px 24px 52px" sm-margin="0px 25px 24px 25px">
						Реальный процент просмотра сообщений в мессенджерах по состоянию на 2023 год составляет в среднем более 50%.
					</Text>
					<Image
						src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Chart%2005.png?v=2022-08-25T10:47:11.830Z"
						display="block"
						position="relative"
						bottom="-1px"
						srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Chart%2005.png?v=2022-08-25T10%3A47%3A11.830Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Chart%2005.png?v=2022-08-25T10%3A47%3A11.830Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Chart%2005.png?v=2022-08-25T10%3A47%3A11.830Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Chart%2005.png?v=2022-08-25T10%3A47%3A11.830Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Chart%2005.png?v=2022-08-25T10%3A47%3A11.830Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Chart%2005.png?v=2022-08-25T10%3A47%3A11.830Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Chart%2005.png?v=2022-08-25T10%3A47%3A11.830Z&quality=85&w=3200 3200w"
						sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
					/>
				</Box>
			</Box>
			<Box
				min-width="100px"
				min-height="100px"
				width="46%"
				padding="12px 12px 12px 12px"
				position="relative"
				z-index="1"
				nout-width="100%"
				sm-padding="12px 0px 12px 0px"
			>
				<Box
					background="--white"
					border-radius="32px"
					padding="52px 52px 52px 52px"
					display="flex"
					flex-direction="column"
					min-height="450px"
					overflow-x="hidden"
					overflow-y="hidden"
					sm-padding="20px 30px 20px 30px"
					transition="--transformOut"
					transform="translateY(0px)"
					hover-transform="translateY(-8px)"
				>
					<Text font="normal 800 32px/130% --fontFamily-googleMontserrat" margin="0px 0px 16px 0px" sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif">
						Никакого кода
					</Text>
					<Text font="--base" margin="0px 0px 24px 0px">
						Создать веб-бота, вы можете без кода. Вам лишь нужно будет зарегистрировать сайт и заполнить его товаром
					</Text>
					<Box display="flex" align-items="center" grid-gap="16px" margin="0px 0px 16px 0px">
						<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/done.svg?v=2022-07-20T15:30:46.393Z" display="block" />
						<Text margin="0px 0px 0px 0px" font="--base">
							Готовые шаблоны
						</Text>
					</Box>
					<Box display="flex" align-items="center" grid-gap="16px" margin="0px 0px 16px 0px">
						<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/done.svg?v=2022-07-20T15:30:46.393Z" display="block" />
						<Text margin="0px 0px 0px 0px" font="--base">
							Кнопочное меню бота
						</Text>
					</Box>
					<Box display="flex" align-items="center" grid-gap="16px" margin="0px 0px 16px 0px">
						<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/done.svg?v=2022-07-20T15:30:46.393Z" display="block" />
						<Text margin="0px 0px 0px 0px" font="--base">
							Автоматизация взаимодействия
						</Text>
					</Box>
					<Box display="flex" align-items="center" grid-gap="16px" margin="0px 0px 0px 0px">
						<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/done.svg?v=2022-07-20T15:30:46.393Z" display="block" />
						<Text margin="0px 0px 0px 0px" font="--base">
							Конструктор оплаты и доставки
						</Text>
					</Box>
				</Box>
			</Box>
			<Box
				min-width="100px"
				min-height="100px"
				width="46%"
				padding="12px 12px 12px 12px"
				position="relative"
				z-index="1"
				nout-width="100%"
				sm-padding="12px 0px 12px 0px"
			>
				<Box
					background="--white"
					border-radius="32px"
					padding="52px 52px 0px 52px"
					display="flex"
					flex-direction="column"
					min-height="450px"
					overflow-x="hidden"
					overflow-y="hidden"
					sm-padding="20px 20px 20px 20px"
					sm-min-height="0px"
					transition="--transformOut"
					transform="translateY(0px)"
					hover-transform="translateY(-8px)"
				>
					<Text font="normal 800 32px/130% --fontFamily-googleMontserrat" margin="0px 0px 16px 0px" sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif">
						Синхронизация
					</Text>
					<Text font="--base" margin="0px 0px 40px 0px">
						Интернет-магазин uShop и в веб-бот синхронизируются автоматически.
					</Text>
					<Image
						src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Group%20335626.png?v=2022-08-25T11:31:25.059Z"
						display="block"
						max-height="250px"
						srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%20335626.png?v=2022-08-25T11%3A31%3A25.059Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%20335626.png?v=2022-08-25T11%3A31%3A25.059Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%20335626.png?v=2022-08-25T11%3A31%3A25.059Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%20335626.png?v=2022-08-25T11%3A31%3A25.059Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%20335626.png?v=2022-08-25T11%3A31%3A25.059Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%20335626.png?v=2022-08-25T11%3A31%3A25.059Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%20335626.png?v=2022-08-25T11%3A31%3A25.059Z&quality=85&w=3200 3200w"
						sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
					/>
				</Box>
			</Box>
			<Box
				min-width="100px"
				min-height="100px"
				width="54%"
				padding="12px 12px 12px 12px"
				position="relative"
				nout-width="100%"
				sm-padding="12px 0px 12px 0px"
			>
				<Box
					background="--white"
					border-radius="32px"
					padding="52px 52px 0px 0px"
					display="flex"
					flex-direction="column"
					min-height="450px"
					overflow-x="hidden"
					overflow-y="hidden"
					justify-content="space-between"
					sm-padding="20px 0px 0px 20px"
					sm-min-height="0px"
					transition="--transformOut"
					transform="translateY(0px)"
					hover-transform="translateY(-8px)"
				>
					<Box>
						<Text font="normal 800 32px/130% --fontFamily-googleMontserrat" margin="0px 0px 16px 52px" sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif" sm-margin="0px 20px 16px 20px">
							Все преимущества uShop
						</Text>
						<Text font="--base" margin="0px 52px 24px 52px" sm-margin="0px 20px 24px 20px">
							Безлимитное количество товаров с массой настроек, параметров, фильтров и функций.
						</Text>
					</Box>
					<Image
						src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Group%20335627.png?v=2022-08-25T11:32:01.227Z"
						display="block"
						position="relative"
						bottom="-1px"
						srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%20335627.png?v=2022-08-25T11%3A32%3A01.227Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%20335627.png?v=2022-08-25T11%3A32%3A01.227Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%20335627.png?v=2022-08-25T11%3A32%3A01.227Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%20335627.png?v=2022-08-25T11%3A32%3A01.227Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%20335627.png?v=2022-08-25T11%3A32%3A01.227Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%20335627.png?v=2022-08-25T11%3A32%3A01.227Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%20335627.png?v=2022-08-25T11%3A32%3A01.227Z&quality=85&w=3200 3200w"
						sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
					/>
				</Box>
			</Box>
		</Section>
		<Section
			id="price"
			padding="125px 0 120px 0"
			sm-padding="20px 0 20px 0"
			md-padding="60px 0 20px 0"
			background="linear-gradient(180deg, #F5F6F8 0%, rgba(255, 255, 255, 0.7) 100%)"
		>
			<Box>
				<Text
					margin="0px 0px 6px 0px"
					color="--darkL1"
					font="--headline1"
					md-text-align="center"
					sm-font="normal 800 30px/1.4 &quot;Montserrat&quot;, sans-serif"
				>
					Тарифы
				</Text>
				<Text
					margin="0px 0px 24px 0px"
					color="--dark"
					font="--decsr"
					lg-font="normal 500 16px/180% &quot;Montserrat&quot;, sans-serif"
					md-text-align="center"
					display="block"
				>
					Для реализации полноценного интернет-магазина и веб-бота в Телеграм у нас представлен один тариф "
					<Strong>
						Магазин
					</Strong>
					"
				</Text>
			</Box>
			<Components.Tabs2 defaultTab="one">
				<Override slot="Tab one">
					Показать цены в $
				</Override>
				<Override slot="Tab two" text-align="right">
					Показать цены в ₽
				</Override>
				<Override
					slot="Tab"
					border-radius="0px"
					hover-opacity="1"
					color="--grey"
					focus-box-shadow="none"
					font="--button"
					background="rgba(0, 0, 0, 0)"
					text-align="right"
					border-width="0px 0px 1px 0px"
					border-style="dashed"
					padding="8px 1px 0px 1px"
					margin="0px 10px 10px 0px"
					border-color="--color-grey"
				>
					Показать цены в $
				</Override>
				<Override slot="TabPanels" />
				<Override
					slot="Tab :active"
					border-radius="0px"
					color="--grey"
					text-decoration-line="underline"
					display="none"
				/>
				<Override slot="Tablist" display="flex" flex-direction="row-reverse" flex-wrap="no-wrap" />
				<Components.Tab2 tabId="one">
					<Box
						min-width="100px"
						min-height="100px"
						display="flex"
						grid-gap="24px"
						nout-flex-direction="column"
					>
						<Box
							min-width="100px"
							min-height="100px"
							padding="48px 55px 48px 48px"
							border-radius="32px"
							display="flex"
							flex-direction="column"
							align-items="flex-start"
							background="--white"
							sm-padding="24px 24px 24px 24px"
							nout-padding="48px 24px 48px 24px"
							border-width="2px"
							border-style="solid"
							border-color="--color-primary"
						>
							<Text margin="0px 0px 8px 0px" color="--dark" font="--headline2">
								1 месяц
							</Text>
							<Text
								margin="0px 0px 24px 0px"
								color="--dark"
								font="normal 500 20px/36px --fontFamily-googleMontserrat"
								sm-font="normal 500 16px/24px --fontFamily-googleMontserrat"
								sm-margin="0px 0px 16px 0px"
							>
								Для тех, кто хочет попробовать
							</Text>
							<Text margin="0px 0px 0px 0px" color="--dark" font="normal 800 48px/1.2 &quot;Montserrat&quot;, sans-serif" nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif">
								$9.99
							</Text>
							<Text margin="0px 0px 0px 0px" color="--grey" font="--headline3" lg-font="normal 700 16px/180% --fontFamily-googleMontserrat">
								в месяц
							</Text>
							<Components.ButtonBot
								margin="40px 0px 0px 0px"
								border-radius="12px"
								background="--primary"
								hover-background="--color-dark"
								font="normal 600 16px/1.5 &quot;Montserrat&quot;, sans-serif"
								width="100%"
								sm-margin="16px 0px 0px 0px"
							>
								Попробовать бесплатно
							</Components.ButtonBot>
							<Text
								margin="16px 0px 0px 0px"
								color="--grey"
								font="normal 500 15px/180% --fontFamily-googleMontserrat"
								lg-font="normal 700 16px/180% --fontFamily-googleMontserrat"
								width="100%"
								text-align="center"
							>
								15 дней бесплатно
							</Text>
						</Box>
						<Box
							min-width="100px"
							min-height="100px"
							padding="48px 55px 48px 48px"
							border-radius="32px"
							display="flex"
							flex-direction="column"
							align-items="flex-start"
							background="--white"
							sm-padding="24px 24px 24px 24px"
							position="relative"
							nout-padding="48px 24px 48px 24px"
							border-width="2px"
							border-style="solid"
							border-color="--color-primary"
						>
							<Box
								height="72px"
								width="72px"
								display="flex"
								align-items="center"
								justify-content="center"
								background="--color-yellow"
								border-radius="50%"
								position="absolute"
								top="24px"
								right="24px"
								sm-width="50px"
								sm-height="50px"
								sm-top="16px"
								sm-right="16px"
							>
								<Text margin="0px 0px 0px 0px" font="normal 800 16px/160% --fontFamily-googleMontserrat">
									-20%
								</Text>
							</Box>
							<Text margin="0px 0px 8px 0px" color="--dark" font="--headline2">
								12 месяцев
							</Text>
							<Text
								margin="0px 0px 24px 0px"
								color="--dark"
								font="normal 500 20px/36px --fontFamily-googleMontserrat"
								sm-font="normal 500 16px/24px --fontFamily-googleMontserrat"
								sm-margin="0px 0px 16px 0px"
							>
								Для тех, кто настроен серьезно
							</Text>
							<Text margin="0px 0px 0px 0px" color="--red" font="normal 800 48px/1.2 &quot;Montserrat&quot;, sans-serif" nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif">
								$7.99
								<Span
									color="--grey"
									font="--headline3"
									overflow-wrap="normal"
									word-break="normal"
									white-space="normal"
									text-indent="0"
									text-overflow="clip"
									hyphens="manual"
									user-select="auto"
									pointer-events="auto"
								>
									{" "}/{" "}
									<Span
										overflow-wrap="normal"
										word-break="normal"
										white-space="normal"
										text-indent="0"
										text-overflow="clip"
										hyphens="manual"
										user-select="auto"
										pointer-events="auto"
									>
										<Span text-decoration-line="line-through">
											$9.99
										</Span>
									</Span>
								</Span>
							</Text>
							<Text margin="0px 0px 0px 0px" color="--grey" font="--headline3" lg-font="normal 700 16px/180% --fontFamily-googleMontserrat">
								в месяц
							</Text>
							<Components.ButtonBot
								margin="40px 0px 0px 0px"
								border-radius="12px"
								background="--primary"
								hover-background="--color-dark"
								font="normal 600 16px/1.5 &quot;Montserrat&quot;, sans-serif"
								width="100%"
								sm-margin="16px 0px 0px 0px"
							>
								Попробовать бесплатно
							</Components.ButtonBot>
							<Text
								margin="16px 0px 0px 0px"
								color="--grey"
								font="normal 500 15px/180% --fontFamily-googleMontserrat"
								lg-font="normal 700 16px/180% --fontFamily-googleMontserrat"
								width="100%"
								text-align="center"
							>
								При оплате $95.88 за год
							</Text>
						</Box>
						<Box
							min-width="100px"
							min-height="100px"
							padding="48px 55px 48px 48px"
							border-radius="32px"
							display="flex"
							flex-direction="column"
							align-items="flex-start"
							background="--white"
							sm-padding="24px 24px 24px 24px"
							position="relative"
							nout-padding="48px 24px 48px 24px"
							border-width="2px"
							border-style="solid"
							border-color="--color-primary"
						>
							<Box
								height="72px"
								width="72px"
								align-items="center"
								display="flex"
								justify-content="center"
								background="--color-yellow"
								border-radius="50%"
								position="absolute"
								top="24px"
								right="24px"
								sm-width="50px"
								sm-height="50px"
								sm-top="16px"
								sm-right="16px"
							>
								<Text margin="0px 0px 0px 0px" font="normal 800 16px/160% --fontFamily-googleMontserrat">
									-30%
								</Text>
							</Box>
							<Text margin="0px 0px 8px 0px" color="--dark" font="--headline2">
								24 месяца
							</Text>
							<Text
								margin="0px 0px 24px 0px"
								color="--dark"
								font="normal 500 20px/36px --fontFamily-googleMontserrat"
								sm-font="normal 500 16px/24px --fontFamily-googleMontserrat"
								sm-margin="0px 0px 16px 0px"
							>
								Для тех, кто ищет максимальную выгоду
							</Text>
							<Text margin="0px 0px 0px 0px" color="--red" font="normal 800 48px/1.2 &quot;Montserrat&quot;, sans-serif" nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif">
								$6.99
								<Span
									color="--grey"
									font="--headline3"
									overflow-wrap="normal"
									word-break="normal"
									white-space="normal"
									text-indent="0"
									text-overflow="clip"
									hyphens="manual"
									user-select="auto"
									pointer-events="auto"
								>
									{" "}/{" "}
									<Span text-decoration-line="line-through">
										$9.99
									</Span>
								</Span>
							</Text>
							<Text margin="0px 0px 0px 0px" color="--grey" font="--headline3" lg-font="normal 700 16px/180% --fontFamily-googleMontserrat">
								в месяц
							</Text>
							<Components.ButtonBot
								margin="40px 0px 0px 0px"
								border-radius="12px"
								background="--primary"
								hover-background="--color-dark"
								font="normal 600 16px/1.5 &quot;Montserrat&quot;, sans-serif"
								width="100%"
								sm-margin="16px 0px 0px 0px"
							>
								Попробовать бесплатно
							</Components.ButtonBot>
							<Text
								margin="16px 0px 0px 0px"
								color="--grey"
								font="normal 500 15px/180% --fontFamily-googleMontserrat"
								lg-font="normal 700 16px/180% --fontFamily-googleMontserrat"
								width="100%"
								text-align="center"
							>
								При оплате $167.83 за 2 года
							</Text>
						</Box>
					</Box>
				</Components.Tab2>
				<Components.Tab2 tabId="two" border-width="2px">
					<Box
						min-width="100px"
						min-height="100px"
						display="flex"
						grid-gap="24px"
						nout-display="flex"
						nout-flex-direction="column"
					>
						<Box
							min-width="100px"
							min-height="100px"
							padding="48px 55px 48px 48px"
							border-radius="32px"
							display="flex"
							flex-direction="column"
							align-items="flex-start"
							background="--white"
							sm-padding="24px 24px 24px 24px"
							nout-padding="48px 24px 48px 24px"
							border-width="2px"
							border-style="solid"
							border-color="--color-primary"
						>
							<Text margin="0px 0px 8px 0px" color="--dark" font="--headline2">
								1 месяц
							</Text>
							<Text
								margin="0px 0px 24px 0px"
								color="--dark"
								font="normal 500 20px/36px --fontFamily-googleMontserrat"
								sm-font="normal 500 16px/24px --fontFamily-googleMontserrat"
								sm-margin="0px 0px 16px 0px"
							>
								Для тех, кто хочет попробовать
							</Text>
							<Text margin="0px 0px 0px 0px" color="--dark" font="normal 800 48px/1.2 &quot;Montserrat&quot;, sans-serif" nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif">
								1099
								<Strong
									overflow-wrap="normal"
									word-break="normal"
									white-space="normal"
									text-indent="0"
									text-overflow="clip"
									hyphens="manual"
									user-select="auto"
									pointer-events="auto"
								>
									₽
								</Strong>
							</Text>
							<Text margin="0px 0px 0px 0px" color="--grey" font="--headline3" lg-font="normal 700 16px/180% --fontFamily-googleMontserrat">
								в месяц
							</Text>
							<Components.ButtonBot
								margin="40px 0px 0px 0px"
								border-radius="12px"
								background="--primary"
								hover-background="--color-dark"
								font="normal 600 16px/1.5 &quot;Montserrat&quot;, sans-serif"
								width="100%"
								sm-margin="16px 0px 0px 0px"
							>
								Попробовать бесплатно
							</Components.ButtonBot>
							<Text
								margin="16px 0px 0px 0px"
								color="--grey"
								font="normal 500 15px/180% --fontFamily-googleMontserrat"
								lg-font="normal 700 16px/180% --fontFamily-googleMontserrat"
								width="100%"
								text-align="center"
							>
								15 дней бесплатно
							</Text>
						</Box>
						<Box
							min-width="100px"
							min-height="100px"
							padding="48px 55px 48px 48px"
							border-radius="32px"
							display="flex"
							flex-direction="column"
							align-items="flex-start"
							background="--white"
							sm-padding="24px 24px 24px 24px"
							position="relative"
							nout-padding="48px 24px 48px 24px"
							border-width="2px"
							border-style="solid"
							border-color="--color-primary"
						>
							<Box
								height="72px"
								width="72px"
								display="flex"
								align-items="center"
								justify-content="center"
								background="--color-yellow"
								border-radius="50%"
								position="absolute"
								top="24px"
								right="24px"
								sm-width="50px"
								sm-height="50px"
								sm-top="16px"
								sm-right="16px"
							>
								<Text margin="0px 0px 0px 0px" font="normal 800 16px/160% --fontFamily-googleMontserrat">
									-20%
								</Text>
							</Box>
							<Text margin="0px 0px 8px 0px" color="--dark" font="--headline2">
								12 месяцев
							</Text>
							<Text
								margin="0px 0px 24px 0px"
								color="--dark"
								font="normal 500 20px/36px --fontFamily-googleMontserrat"
								sm-font="normal 500 16px/24px --fontFamily-googleMontserrat"
								sm-margin="0px 0px 16px 0px"
							>
								Для тех, кто настроен серьезно
							</Text>
							<Text margin="0px 0px 0px 0px" color="--red" font="normal 800 48px/1.2 &quot;Montserrat&quot;, sans-serif" nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif">
								879₽
								<Span
									color="--grey"
									font="--headline3"
									overflow-wrap="normal"
									word-break="normal"
									white-space="normal"
									text-indent="0"
									text-overflow="clip"
									hyphens="manual"
									user-select="auto"
									pointer-events="auto"
								>
									{" "}/{" "}
									<Span
										overflow-wrap="normal"
										word-break="normal"
										white-space="normal"
										text-indent="0"
										text-overflow="clip"
										hyphens="manual"
										user-select="auto"
										pointer-events="auto"
									>
										<Span
											text-decoration-line="line-through"
											overflow-wrap="normal"
											word-break="normal"
											white-space="normal"
											text-indent="0"
											text-overflow="clip"
											hyphens="manual"
											user-select="auto"
											pointer-events="auto"
										>
											1099₽
										</Span>
									</Span>
								</Span>
							</Text>
							<Text margin="0px 0px 0px 0px" color="--grey" font="--headline3" lg-font="normal 700 16px/180% --fontFamily-googleMontserrat">
								в месяц
							</Text>
							<Components.ButtonBot
								margin="40px 0px 0px 0px"
								border-radius="12px"
								background="--primary"
								hover-background="--color-dark"
								font="normal 600 16px/1.5 &quot;Montserrat&quot;, sans-serif"
								width="100%"
								sm-margin="16px 0px 0px 0px"
							>
								Попробовать бесплатно
							</Components.ButtonBot>
							<Text
								margin="16px 0px 0px 0px"
								color="--grey"
								font="normal 500 15px/180% --fontFamily-googleMontserrat"
								lg-font="normal 700 16px/180% --fontFamily-googleMontserrat"
								width="100%"
								text-align="center"
							>
								При оплате 10 550 ₽

 за год
							</Text>
						</Box>
						<Box
							min-width="100px"
							min-height="100px"
							padding="48px 55px 48px 48px"
							border-radius="32px"
							display="flex"
							flex-direction="column"
							align-items="flex-start"
							background="--white"
							sm-padding="24px 24px 24px 24px"
							position="relative"
							nout-padding="48px 24px 48px 24px"
							border-width="2px"
							border-style="solid"
							border-color="--color-primary"
						>
							<Box
								height="72px"
								width="72px"
								align-items="center"
								display="flex"
								justify-content="center"
								background="--color-yellow"
								border-radius="50%"
								position="absolute"
								top="24px"
								right="24px"
								sm-width="50px"
								sm-height="50px"
								sm-top="16px"
								sm-right="16px"
							>
								<Text margin="0px 0px 0px 0px" font="normal 800 16px/160% --fontFamily-googleMontserrat">
									-30%
								</Text>
							</Box>
							<Text margin="0px 0px 8px 0px" color="--dark" font="--headline2">
								24 месяца
							</Text>
							<Text
								margin="0px 0px 24px 0px"
								color="--dark"
								font="normal 500 20px/36px --fontFamily-googleMontserrat"
								sm-font="normal 500 16px/24px --fontFamily-googleMontserrat"
								sm-margin="0px 0px 16px 0px"
							>
								Для тех, кто ищет максимальную выгоду
							</Text>
							<Text margin="0px 0px 0px 0px" color="--red" font="normal 800 48px/1.2 &quot;Montserrat&quot;, sans-serif" nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif">
								769₽
								<Span
									color="--grey"
									font="--headline3"
									overflow-wrap="normal"
									word-break="normal"
									white-space="normal"
									text-indent="0"
									text-overflow="clip"
									hyphens="manual"
									user-select="auto"
									pointer-events="auto"
								>
									{" "}/{" "}
									<Span
										text-decoration-line="line-through"
										overflow-wrap="normal"
										word-break="normal"
										white-space="normal"
										text-indent="0"
										text-overflow="clip"
										hyphens="manual"
										user-select="auto"
										pointer-events="auto"
									>
										1099₽
									</Span>
								</Span>
							</Text>
							<Text margin="0px 0px 0px 0px" color="--grey" font="--headline3" lg-font="normal 700 16px/180% --fontFamily-googleMontserrat">
								в месяц
							</Text>
							<Components.ButtonBot
								margin="40px 0px 0px 0px"
								border-radius="12px"
								background="--primary"
								hover-background="--color-dark"
								font="normal 600 16px/1.5 &quot;Montserrat&quot;, sans-serif"
								width="100%"
								sm-margin="16px 0px 0px 0px"
							>
								Попробовать бесплатно
							</Components.ButtonBot>
							<Text
								margin="16px 0px 0px 0px"
								color="--grey"
								font="normal 500 15px/180% --fontFamily-googleMontserrat"
								lg-font="normal 700 16px/180% --fontFamily-googleMontserrat"
								width="100%"
								text-align="center"
							>
								При оплате 18 460 
₽

за 2 года
							</Text>
						</Box>
					</Box>
				</Components.Tab2>
			</Components.Tabs2>
			<Box
				display="flex"
				align-items="center"
				justify-content="center"
				position="relative"
				margin="64px 0px 0px 0px"
				lg-margin="20px 0px 0px 0px"
				sm-margin="40px 0px 0px 0px"
			>
				<Hr
					margin="0px 0px 0px 0px"
					border-color="--color-greyD1"
					border-width="2px 0 0 0"
					width="100%"
					position="absolute"
					sm-display="none"
				/>
				<Text
					margin="0px 0px 0px 0px"
					font="normal 800 24px/31px --fontFamily-googleMontserrat"
					text-align="center"
					color="--grey"
					position="relative"
					z-index="1"
					background="#FBFBFC"
					padding="0px 15px 10px 15px"
					sm-padding="0px 15px 0px 15px"
					sm-font="normal 800 20px/24px --fontFamily-googleMontserrat"
				>
					все тарифы включают в себя
				</Text>
			</Box>
			<Box
				display="grid"
				grid-template-columns="repeat(3, 1fr)"
				margin="40px 0px 0px 0px"
				grid-gap="24px"
				lg-grid-template-columns="repeat(2, 1fr)"
				sm-grid-template-columns="1fr"
				sm-margin="15px 0px 0px 0px"
			>
				<Box
					display="flex"
					padding="40px 40px 40px 40px"
					border-radius="32px"
					background="--color-white"
					justify-content="flex-start"
					flex-direction="column"
					nout-padding="20px 20px 20px 20px"
					border-width="1px"
					border-color="--color-primary"
					border-style="solid"
				>
					<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/infinity%201.svg?v=2024-04-04T18:04:24.771Z" display="block" max-height="48px" object-position="0%" />
					<Text margin="24px 0px 16px 0px" font="normal 800 24px/130% --fontFamily-googleMontserrat" md-font="normal 800 18px/130% --fontFamily-googleMontserrat">
						Нет никаких лимитов
					</Text>
					<Text margin="0px 0px 0px 0px" font="--base" md-font="normal 500 14px/120% &quot;Montserrat&quot;, sans-serif">
						У нас нет лимита по доходу и количеству подписчиков, как это у других конструкторов
					</Text>
				</Box>
				<Box
					display="flex"
					padding="40px 40px 40px 40px"
					border-radius="32px"
					background="--color-white"
					justify-content="flex-start"
					flex-direction="column"
					nout-padding="20px 20px 20px 20px"
					border-width="1px"
					border-color="--color-primary"
					border-style="solid"
				>
					<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Frame%20427320931.svg?v=2024-04-04T18:04:24.765Z" display="block" max-height="48px" object-position="0%" />
					<Text margin="24px 0px 16px 0px" font="normal 800 24px/130% --fontFamily-googleMontserrat" md-font="normal 800 18px/130% --fontFamily-googleMontserrat">
						Интеграция со службами доставки
					</Text>
					<Text margin="0px 0px 0px 0px" font="--base" md-font="normal 500 14px/120% &quot;Montserrat&quot;, sans-serif">
						Интеграция со СДЭК, Почта России, Нова Пошта, КазПочта, Boxberry и многие другие
					</Text>
				</Box>
				<Box
					display="flex"
					padding="40px 40px 40px 40px"
					border-radius="32px"
					background="--color-white"
					justify-content="flex-start"
					flex-direction="column"
					nout-padding="20px 20px 20px 20px"
					border-width="1px"
					border-color="--color-primary"
					border-style="solid"
				>
					<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/stop-sign%201.svg?v=2024-04-04T18:04:24.770Z" display="block" max-height="48px" object-position="0%" />
					<Text margin="24px 0px 16px 0px" font="normal 800 24px/130% --fontFamily-googleMontserrat" md-font="normal 800 18px/130% --fontFamily-googleMontserrat">
						Нет сторонней рекламы
					</Text>
					<Text margin="0px 0px 0px 0px" font="--base" md-font="normal 500 14px/120% &quot;Montserrat&quot;, sans-serif">
						В вашем боте не размещается сторонняя реклама или реклама нашего конструктора
					</Text>
				</Box>
				<Box
					display="flex"
					padding="40px 40px 40px 40px"
					border-radius="32px"
					background="--color-white"
					justify-content="flex-start"
					flex-direction="column"
					nout-padding="20px 20px 20px 20px"
					border-width="1px"
					border-color="--color-primary"
					border-style="solid"
				>
					<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Frame%20427320932.svg?v=2024-04-04T18:04:24.765Z" display="block" max-height="48px" object-position="0%" />
					<Text margin="24px 0px 16px 0px" font="normal 800 24px/130% --fontFamily-googleMontserrat" md-font="normal 800 18px/130% --fontFamily-googleMontserrat">
						Онлайн прием платежей
					</Text>
					<Text margin="0px 0px 0px 0px" font="--base" md-font="normal 500 14px/120% &quot;Montserrat&quot;, sans-serif">
						Можно принимать оплату в боте при помощи банковских карт со всех стран мира
						<br />
						(VISA, MasterCard, МИР и пр.)
					</Text>
				</Box>
				<Box
					display="flex"
					padding="40px 40px 40px 40px"
					border-radius="32px"
					background="--color-white"
					justify-content="flex-start"
					flex-direction="column"
					nout-padding="20px 20px 20px 20px"
					border-width="1px"
					border-color="--color-primary"
					border-style="solid"
				>
					<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Frame%20427320934.svg?v=2024-04-04T18:04:24.775Z" display="block" max-height="48px" object-position="0%" />
					<Text margin="24px 0px 16px 0px" font="normal 800 24px/130% --fontFamily-googleMontserrat" md-font="normal 800 18px/130% --fontFamily-googleMontserrat">
						Импорт товаров
					</Text>
					<Text margin="0px 0px 0px 0px" font="--base" md-font="normal 500 14px/120% &quot;Montserrat&quot;, sans-serif">
						У нас есть импорт товара с Excel (XLS/XLSX/Google Docs) и 1C/МойСклад/YML
						<br />
						(Яндекс. Маркет и прочие)
					</Text>
				</Box>
				<Box
					display="flex"
					padding="40px 40px 40px 40px"
					border-radius="32px"
					background="--color-white"
					justify-content="flex-start"
					flex-direction="column"
					nout-padding="20px 20px 20px 20px"
					border-width="1px"
					border-color="--color-primary"
					border-style="solid"
				>
					<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Frame%20427320931-1.svg?v=2024-04-04T18:04:24.766Z" display="block" max-height="48px" object-position="0%" />
					<Text margin="24px 0px 16px 0px" font="normal 800 24px/130% --fontFamily-googleMontserrat" md-font="normal 800 18px/130% --fontFamily-googleMontserrat">
						Прием криптовалюты
					</Text>
					<Text margin="0px 0px 0px 0px" font="--base" md-font="normal 500 14px/120% &quot;Montserrat&quot;, sans-serif">
						Для оплаты товара вы можете принимать криптовалюту (BTC, ETH, USDT, TON и пр.)
					</Text>
				</Box>
			</Box>
			<Box
				border-width="2px"
				border-style="solid"
				border-color="--color-white"
				padding="0px 48px 0px 48px"
				border-radius="32px"
				display="grid"
				flex-direction="row"
				background="--dark"
				align-items="center"
				height="100%"
				justify-content="space-between"
				sm-padding="7px 24px 7px 16px"
				grid-template-columns="3fr 2fr"
				grid-gap="80px"
				justify-items="center"
				position="relative"
				margin="66px 0px 0px 0px"
				lg-display="flex"
				lg-overflow-x="hidden"
				lg-overflow-y="hidden"
				lg-padding="0px 20px 0px 20px"
				lg-margin="20px 0px 0px 0px"
				overflow-x="hidden"
				overflow-y="hidden"
			>
				<Box
					min-width="100px"
					min-height="100px"
					display="flex"
					flex-direction="column"
					justify-content="center"
					align-items="flex-start"
					position="relative"
					z-index="1"
					lg-width="100%"
					sm-z-index="2"
				>
					<Text margin="0px 0px 8px 0px" color="--white" font="normal 800 28px/180% --fontFamily-googleMontserrat">
						Магазин под ключ
					</Text>
					<Text
						margin="0px 0px 24px 0px"
						color="--white"
						font="normal 500 20px/36px --fontFamily-googleMontserrat"
						sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif"
						md-font="normal 500 16px/24px --fontFamily-googleMontserrat"
						sm-margin="0px 0px 16px 0px"
					>
						Если у вас нет времени заниматься созданием и оформление бота (добавлять товар, настраивать импорт, подключать онлайн оплату и интегрировать службы доставки), то вы можете заказать у нас услугу под ключ
					</Text>
					<Text
						margin="0px 0px 24px 0px"
						color="--red"
						font="--headline1"
						nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
						lg-font="normal 800 24px/1.4 &quot;Montserrat&quot;, sans-serif"
						sm-margin="0px 0px 16px 0px"
					>
						9800 руб.{" "}
					</Text>
					<Box />
					<Link
						href="https://bot.divly.pro/?utm_source=ucozbotmain&utm_medium=banner&utm_content=tarif"
						color="--white"
						font="--button"
						text-decoration-line="initial"
						padding="16px 24px 16px 24px"
						border-radius="12px"
						transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
						hover-color="--dark"
						hover-background="--background"
						target="_blank"
						background="--primary"
						display="flex"
						box-shadow="0px 4px 16px 0px rgba(14, 134, 248, 0.08)"
					>
						Заказать магазин под ключ
					</Link>
					<Box>
						<Text
							margin="24px 0px 0px 0px"
							color="--greyD1"
							font="--base"
							sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif"
							md-margin="8px 0px 0px 0px"
						>
							срок создания в среднем 5 дней
						</Text>
					</Box>
				</Box>
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Group%203334240.png?v=2024-04-04T16:55:09.434Z"
					display="block"
					margin="48px 0px -20px 0px"
					position="relative"
					z-index="1"
					lg-position="absolute"
					lg-bottom="0px"
					lg-right="0px"
					lg-width="20%"
					md-width="27%"
					lg-margin="0px 0px 0px 0px"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%203334240.png?v=2024-04-04T16%3A55%3A09.434Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%203334240.png?v=2024-04-04T16%3A55%3A09.434Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%203334240.png?v=2024-04-04T16%3A55%3A09.434Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%203334240.png?v=2024-04-04T16%3A55%3A09.434Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%203334240.png?v=2024-04-04T16%3A55%3A09.434Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%203334240.png?v=2024-04-04T16%3A55%3A09.434Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%203334240.png?v=2024-04-04T16%3A55%3A09.434Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
				<Box
					position="absolute"
					background="rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/62ab65c921e43d0020961286/images/shapeofyou.png?v=2024-04-04T17:45:01.485Z) 0% 0% /100% no-repeat scroll padding-box"
					width="100%"
					height="100%"
					nout-background="rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/62ab65c921e43d0020961286/images/shapeofyou.png?v=2024-04-04T17:45:01.485Z) bottom/100% no-repeat scroll padding-box"
					lg-right="0px"
					lg-background="none"
				/>
			</Box>
		</Section>
		<Structure
			padding="125px 0px 120px 0px"
			background="linear-gradient(180deg, #F5F6F8 0%, rgba(255, 255, 255, 0.7) 100%)"
			nout-padding="60px 0px 60px 0px"
			position="relative"
			cells-number-total="6"
			quarkly-title="Dollar"
			display="none"
		>
			<Override slot="Content" grid-template-columns="1fr 1fr 1fr" grid-gap="24px" lg-grid-template-columns="1fr">
				<Override slot="Cell 0" grid-column="1 / span 3" lg-grid-column="auto / auto" />
				<Override slot="cell-0">
					<Text
						margin="0px 0px 6px 0px"
						color="--darkL1"
						font="--headline1"
						md-text-align="center"
						sm-font="normal 800 30px/1.4 &quot;Montserrat&quot;, sans-serif"
					>
						Тарифы
					</Text>
					<Text
						margin="0px 0px 24px 0px"
						color="--dark"
						font="--decsr"
						lg-font="normal 500 16px/180% &quot;Montserrat&quot;, sans-serif"
						md-text-align="center"
					>
						Для реализации полноценного интернет-магазина и веб-бота в Телеграм у нас представлен один тариф "
						<Strong>
							Магазин
						</Strong>
						"
					</Text>
				</Override>
				<Override slot="cell-1">
					<Box
						min-width="100px"
						min-height="100px"
						padding="48px 55px 48px 48px"
						border-radius="32px"
						display="flex"
						flex-direction="column"
						align-items="flex-start"
						background="--white"
						sm-padding="24px 24px 24px 24px"
						nout-padding="48px 24px 48px 24px"
						border-width="2px"
						border-style="solid"
						border-color="--color-primary"
					>
						<Text margin="0px 0px 8px 0px" color="--dark" font="--headline2">
							1 месяц
						</Text>
						<Text
							margin="0px 0px 24px 0px"
							color="--dark"
							font="normal 500 20px/36px --fontFamily-googleMontserrat"
							sm-font="normal 500 16px/24px --fontFamily-googleMontserrat"
							sm-margin="0px 0px 16px 0px"
						>
							Для тех, кто хочет попробовать
						</Text>
						<Text margin="0px 0px 0px 0px" color="--dark" font="normal 800 48px/1.2 &quot;Montserrat&quot;, sans-serif" nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif">
							$9.99
						</Text>
						<Text margin="0px 0px 0px 0px" color="--grey" font="--headline3" lg-font="normal 700 16px/180% --fontFamily-googleMontserrat">
							в месяц
						</Text>
						<Components.ButtonBot
							margin="40px 0px 0px 0px"
							border-radius="12px"
							background="--primary"
							hover-background="--color-dark"
							font="normal 600 16px/1.5 &quot;Montserrat&quot;, sans-serif"
							width="100%"
							sm-margin="16px 0px 0px 0px"
						>
							Попробовать бесплатно
						</Components.ButtonBot>
						<Text
							margin="16px 0px 0px 0px"
							color="--grey"
							font="normal 500 15px/180% --fontFamily-googleMontserrat"
							lg-font="normal 700 16px/180% --fontFamily-googleMontserrat"
							width="100%"
							text-align="center"
						>
							15 дней бесплатно
						</Text>
					</Box>
				</Override>
				<Override slot="cell-2">
					<Box
						min-width="100px"
						min-height="100px"
						padding="48px 55px 48px 48px"
						border-radius="32px"
						display="flex"
						flex-direction="column"
						align-items="flex-start"
						background="--white"
						sm-padding="24px 24px 24px 24px"
						position="relative"
						nout-padding="48px 24px 48px 24px"
						border-width="2px"
						border-style="solid"
						border-color="--color-primary"
					>
						<Box
							height="72px"
							width="72px"
							display="flex"
							align-items="center"
							justify-content="center"
							background="--color-yellow"
							border-radius="50%"
							position="absolute"
							top="24px"
							right="24px"
							sm-width="50px"
							sm-height="50px"
							sm-top="16px"
							sm-right="16px"
						>
							<Text margin="0px 0px 0px 0px" font="normal 800 16px/160% --fontFamily-googleMontserrat">
								-20%
							</Text>
						</Box>
						<Text margin="0px 0px 8px 0px" color="--dark" font="--headline2">
							12 месяцев
						</Text>
						<Text
							margin="0px 0px 24px 0px"
							color="--dark"
							font="normal 500 20px/36px --fontFamily-googleMontserrat"
							sm-font="normal 500 16px/24px --fontFamily-googleMontserrat"
							sm-margin="0px 0px 16px 0px"
						>
							Для тех, кто настроен серьезно
						</Text>
						<Text margin="0px 0px 0px 0px" color="--red" font="normal 800 48px/1.2 &quot;Montserrat&quot;, sans-serif" nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif">
							$7.99
							<Span
								color="--grey"
								font="--headline3"
								overflow-wrap="normal"
								word-break="normal"
								white-space="normal"
								text-indent="0"
								text-overflow="clip"
								hyphens="manual"
								user-select="auto"
								pointer-events="auto"
							>
								{" "}/{" "}
								<Span
									overflow-wrap="normal"
									word-break="normal"
									white-space="normal"
									text-indent="0"
									text-overflow="clip"
									hyphens="manual"
									user-select="auto"
									pointer-events="auto"
								>
									<Span text-decoration-line="line-through">
										$9.99
									</Span>
								</Span>
							</Span>
						</Text>
						<Text margin="0px 0px 0px 0px" color="--grey" font="--headline3" lg-font="normal 700 16px/180% --fontFamily-googleMontserrat">
							в месяц
						</Text>
						<Components.ButtonBot
							margin="40px 0px 0px 0px"
							border-radius="12px"
							background="--primary"
							hover-background="--color-dark"
							font="normal 600 16px/1.5 &quot;Montserrat&quot;, sans-serif"
							width="100%"
							sm-margin="16px 0px 0px 0px"
						>
							Попробовать бесплатно
						</Components.ButtonBot>
						<Text
							margin="16px 0px 0px 0px"
							color="--grey"
							font="normal 500 15px/180% --fontFamily-googleMontserrat"
							lg-font="normal 700 16px/180% --fontFamily-googleMontserrat"
							width="100%"
							text-align="center"
						>
							При оплате $95.88 за год
						</Text>
					</Box>
				</Override>
				<Override slot="Cell 0th" border-radius="32px" lg-grid-column="auto / auto" />
				<Override slot="Cell 3" />
				<Override slot="cell-3">
					<Box
						min-width="100px"
						min-height="100px"
						padding="48px 55px 48px 48px"
						border-radius="32px"
						display="flex"
						flex-direction="column"
						align-items="flex-start"
						background="--white"
						sm-padding="24px 24px 24px 24px"
						position="relative"
						nout-padding="48px 24px 48px 24px"
						border-width="2px"
						border-style="solid"
						border-color="--color-primary"
					>
						<Box
							height="72px"
							width="72px"
							align-items="center"
							display="flex"
							justify-content="center"
							background="--color-yellow"
							border-radius="50%"
							position="absolute"
							top="24px"
							right="24px"
							sm-width="50px"
							sm-height="50px"
							sm-top="16px"
							sm-right="16px"
						>
							<Text margin="0px 0px 0px 0px" font="normal 800 16px/160% --fontFamily-googleMontserrat">
								-30%
							</Text>
						</Box>
						<Text margin="0px 0px 8px 0px" color="--dark" font="--headline2">
							24 месяца
						</Text>
						<Text
							margin="0px 0px 24px 0px"
							color="--dark"
							font="normal 500 20px/36px --fontFamily-googleMontserrat"
							sm-font="normal 500 16px/24px --fontFamily-googleMontserrat"
							sm-margin="0px 0px 16px 0px"
						>
							Для тех, кто ищет максимальную выгоду
						</Text>
						<Text margin="0px 0px 0px 0px" color="--red" font="normal 800 48px/1.2 &quot;Montserrat&quot;, sans-serif" nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif">
							$6.99
							<Span
								color="--grey"
								font="--headline3"
								overflow-wrap="normal"
								word-break="normal"
								white-space="normal"
								text-indent="0"
								text-overflow="clip"
								hyphens="manual"
								user-select="auto"
								pointer-events="auto"
							>
								{" "}/{" "}
								<Span text-decoration-line="line-through">
									$9.99
								</Span>
							</Span>
						</Text>
						<Text margin="0px 0px 0px 0px" color="--grey" font="--headline3" lg-font="normal 700 16px/180% --fontFamily-googleMontserrat">
							в месяц
						</Text>
						<Components.ButtonBot
							margin="40px 0px 0px 0px"
							border-radius="12px"
							background="--primary"
							hover-background="--color-dark"
							font="normal 600 16px/1.5 &quot;Montserrat&quot;, sans-serif"
							width="100%"
							sm-margin="16px 0px 0px 0px"
						>
							Попробовать бесплатно
						</Components.ButtonBot>
						<Text
							margin="16px 0px 0px 0px"
							color="--grey"
							font="normal 500 15px/180% --fontFamily-googleMontserrat"
							lg-font="normal 700 16px/180% --fontFamily-googleMontserrat"
							width="100%"
							text-align="center"
						>
							При оплате $167.83 за 2 года
						</Text>
					</Box>
				</Override>
				<Override slot="cell-4">
					<Box
						display="flex"
						align-items="center"
						justify-content="center"
						position="relative"
						margin="40px 0px 0px 0px"
						lg-margin="20px 0px 0px 0px"
					>
						<Hr
							margin="0px 0px 0px 0px"
							border-color="--color-greyD1"
							border-width="2px 0 0 0"
							width="100%"
							position="absolute"
							sm-display="none"
						/>
						<Text
							margin="0px 0px 0px 0px"
							font="normal 800 24px/31px --fontFamily-googleMontserrat"
							text-align="center"
							color="--grey"
							position="relative"
							z-index="1"
							background="#FBFBFC"
							padding="0px 15px 10px 15px"
							sm-padding="0px 15px 0px 15px"
							sm-font="normal 800 20px/24px --fontFamily-googleMontserrat"
						>
							все тарифы включают в себя
						</Text>
					</Box>
					<Box
						display="grid"
						grid-template-columns="repeat(3, 1fr)"
						margin="40px 0px 0px 0px"
						grid-gap="24px"
						lg-grid-template-columns="repeat(2, 1fr)"
						sm-grid-template-columns="1fr"
						sm-margin="15px 0px 0px 0px"
					>
						<Box
							display="flex"
							padding="40px 40px 40px 40px"
							border-radius="32px"
							background="--color-white"
							justify-content="flex-start"
							flex-direction="column"
							nout-padding="20px 20px 20px 20px"
							border-width="1px"
							border-color="--color-primary"
							border-style="solid"
						>
							<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/infinity%201.svg?v=2024-04-04T18:04:24.771Z" display="block" max-height="48px" object-position="0%" />
							<Text margin="24px 0px 16px 0px" font="normal 800 24px/130% --fontFamily-googleMontserrat" md-font="normal 800 18px/130% --fontFamily-googleMontserrat">
								Нет никаких лимитов
							</Text>
							<Text margin="0px 0px 0px 0px" font="--base" md-font="normal 500 14px/120% &quot;Montserrat&quot;, sans-serif">
								У нас нет лимита по доходу и количеству подписчиков, как это у других конструкторов
							</Text>
						</Box>
						<Box
							display="flex"
							padding="40px 40px 40px 40px"
							border-radius="32px"
							background="--color-white"
							justify-content="flex-start"
							flex-direction="column"
							nout-padding="20px 20px 20px 20px"
							border-width="1px"
							border-color="--color-primary"
							border-style="solid"
						>
							<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Frame%20427320931.svg?v=2024-04-04T18:04:24.765Z" display="block" max-height="48px" object-position="0%" />
							<Text margin="24px 0px 16px 0px" font="normal 800 24px/130% --fontFamily-googleMontserrat" md-font="normal 800 18px/130% --fontFamily-googleMontserrat">
								Интеграция со службами доставки
							</Text>
							<Text margin="0px 0px 0px 0px" font="--base" md-font="normal 500 14px/120% &quot;Montserrat&quot;, sans-serif">
								Интеграция со СДЭК, Почта России, Нова Пошта, КазПочта, Boxberry и многие другие
							</Text>
						</Box>
						<Box
							display="flex"
							padding="40px 40px 40px 40px"
							border-radius="32px"
							background="--color-white"
							justify-content="flex-start"
							flex-direction="column"
							nout-padding="20px 20px 20px 20px"
							border-width="1px"
							border-color="--color-primary"
							border-style="solid"
						>
							<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/stop-sign%201.svg?v=2024-04-04T18:04:24.770Z" display="block" max-height="48px" object-position="0%" />
							<Text margin="24px 0px 16px 0px" font="normal 800 24px/130% --fontFamily-googleMontserrat" md-font="normal 800 18px/130% --fontFamily-googleMontserrat">
								Нет сторонней рекламы
							</Text>
							<Text margin="0px 0px 0px 0px" font="--base" md-font="normal 500 14px/120% &quot;Montserrat&quot;, sans-serif">
								В вашем боте не размещается сторонняя реклама или реклама нашего конструктора
							</Text>
						</Box>
						<Box
							display="flex"
							padding="40px 40px 40px 40px"
							border-radius="32px"
							background="--color-white"
							justify-content="flex-start"
							flex-direction="column"
							nout-padding="20px 20px 20px 20px"
							border-width="1px"
							border-color="--color-primary"
							border-style="solid"
						>
							<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Frame%20427320932.svg?v=2024-04-04T18:04:24.765Z" display="block" max-height="48px" object-position="0%" />
							<Text margin="24px 0px 16px 0px" font="normal 800 24px/130% --fontFamily-googleMontserrat" md-font="normal 800 18px/130% --fontFamily-googleMontserrat">
								Онлайн прием платежей
							</Text>
							<Text margin="0px 0px 0px 0px" font="--base" md-font="normal 500 14px/120% &quot;Montserrat&quot;, sans-serif">
								Можно принимать оплату в боте при помощи банковских карт со всех стран мира
								<br />
								(VISA, MasterCard, МИР и пр.)
							</Text>
						</Box>
						<Box
							display="flex"
							padding="40px 40px 40px 40px"
							border-radius="32px"
							background="--color-white"
							justify-content="flex-start"
							flex-direction="column"
							nout-padding="20px 20px 20px 20px"
							border-width="1px"
							border-color="--color-primary"
							border-style="solid"
						>
							<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Frame%20427320934.svg?v=2024-04-04T18:04:24.775Z" display="block" max-height="48px" object-position="0%" />
							<Text margin="24px 0px 16px 0px" font="normal 800 24px/130% --fontFamily-googleMontserrat" md-font="normal 800 18px/130% --fontFamily-googleMontserrat">
								Импорт товаров
							</Text>
							<Text margin="0px 0px 0px 0px" font="--base" md-font="normal 500 14px/120% &quot;Montserrat&quot;, sans-serif">
								У нас есть импорт товара с Excel (XLS/XLSX/Google Docs) и 1C/МойСклад/YML
								<br />
								(Яндекс. Маркет и прочие)
							</Text>
						</Box>
						<Box
							display="flex"
							padding="40px 40px 40px 40px"
							border-radius="32px"
							background="--color-white"
							justify-content="flex-start"
							flex-direction="column"
							nout-padding="20px 20px 20px 20px"
							border-width="1px"
							border-color="--color-primary"
							border-style="solid"
						>
							<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Frame%20427320931-1.svg?v=2024-04-04T18:04:24.766Z" display="block" max-height="48px" object-position="0%" />
							<Text margin="24px 0px 16px 0px" font="normal 800 24px/130% --fontFamily-googleMontserrat" md-font="normal 800 18px/130% --fontFamily-googleMontserrat">
								Прием криптовалюты
							</Text>
							<Text margin="0px 0px 0px 0px" font="--base" md-font="normal 500 14px/120% &quot;Montserrat&quot;, sans-serif">
								Для оплаты товара вы можете принимать криптовалюту (BTC, ETH, USDT, TON и пр.)
							</Text>
						</Box>
					</Box>
				</Override>
				<Override slot="Cell 4" grid-column="1 / span 3" />
				<Override slot="Cell 5" grid-column="1 / span 3" />
				<Override slot="cell-5">
					<Box
						border-width="2px"
						border-style="solid"
						border-color="--color-white"
						padding="0px 48px 0px 48px"
						border-radius="32px"
						display="grid"
						flex-direction="row"
						background="--dark"
						align-items="center"
						height="100%"
						justify-content="space-between"
						sm-padding="7px 24px 7px 16px"
						grid-template-columns="3fr 2fr"
						grid-gap="80px"
						justify-items="center"
						position="relative"
						margin="40px 0px 0px 0px"
						lg-display="flex"
						lg-overflow-x="hidden"
						lg-overflow-y="hidden"
						lg-padding="0px 20px 0px 20px"
						lg-margin="20px 0px 0px 0px"
					>
						<Box
							min-width="100px"
							min-height="100px"
							display="flex"
							flex-direction="column"
							justify-content="center"
							align-items="flex-start"
							position="relative"
							z-index="1"
							lg-width="100%"
							sm-z-index="2"
						>
							<Text margin="0px 0px 8px 0px" color="--white" font="normal 800 28px/180% --fontFamily-googleMontserrat">
								Магазин под ключ
							</Text>
							<Text
								margin="0px 0px 24px 0px"
								color="--white"
								font="normal 500 20px/36px --fontFamily-googleMontserrat"
								sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif"
								md-font="normal 500 16px/24px --fontFamily-googleMontserrat"
								sm-margin="0px 0px 16px 0px"
							>
								Если у вас нет времени заниматься созданием и оформление бота (добавлять товар, настраивать импорт, подключать онлайн оплату и интегрировать службы доставки), то вы можете заказать у нас услугу под ключ
							</Text>
							<Text
								margin="0px 0px 24px 0px"
								color="--red"
								font="--headline1"
								nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
								lg-font="normal 800 24px/1.4 &quot;Montserrat&quot;, sans-serif"
								sm-margin="0px 0px 16px 0px"
							>
								4000 руб.{" "}
							</Text>
							<Box />
							<Link
								href="https://bot.divly.pro/?utm_source=ucozbotmain&utm_medium=banner&utm_content=tarif"
								color="--white"
								font="--button"
								text-decoration-line="initial"
								padding="16px 24px 16px 24px"
								border-radius="12px"
								transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
								hover-color="--dark"
								hover-background="--background"
								target="_blank"
								background="--primary"
								display="flex"
								box-shadow="0px 4px 16px 0px rgba(14, 134, 248, 0.08)"
							>
								Заказать магазин под ключ
							</Link>
							<Box>
								<Text
									margin="24px 0px 0px 0px"
									color="--greyD1"
									font="--base"
									sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif"
									md-margin="8px 0px 0px 0px"
								>
									срок создания в среднем 5 дней
								</Text>
							</Box>
						</Box>
						<Image
							src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/Group%203334240.png?v=2024-04-04T16:55:09.434Z"
							display="block"
							margin="48px 0px -20px 0px"
							position="relative"
							z-index="1"
							lg-position="absolute"
							lg-bottom="0px"
							lg-right="0px"
							lg-width="20%"
							md-width="27%"
							lg-margin="0px 0px 0px 0px"
							srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%203334240.png?v=2024-04-04T16%3A55%3A09.434Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%203334240.png?v=2024-04-04T16%3A55%3A09.434Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%203334240.png?v=2024-04-04T16%3A55%3A09.434Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%203334240.png?v=2024-04-04T16%3A55%3A09.434Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%203334240.png?v=2024-04-04T16%3A55%3A09.434Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%203334240.png?v=2024-04-04T16%3A55%3A09.434Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/Group%203334240.png?v=2024-04-04T16%3A55%3A09.434Z&quality=85&w=3200 3200w"
							sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
						/>
						<Box
							position="absolute"
							background="rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/62ab65c921e43d0020961286/images/shapeofyou.png?v=2024-04-04T17:45:01.485Z) 0% 0% /100% no-repeat scroll padding-box"
							width="100%"
							height="100%"
							nout-background="rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/62ab65c921e43d0020961286/images/shapeofyou.png?v=2024-04-04T17:45:01.485Z) bottom/100% no-repeat scroll padding-box"
							lg-right="0px"
							lg-background="none"
						/>
					</Box>
				</Override>
			</Override>
		</Structure>
		<Structure
			id="price"
			padding="125px 0px 65px 0px"
			background="linear-gradient(180deg, #F5F6F8 0%, rgba(255, 255, 255, 0.7) 100%)"
			nout-padding="60px 0px 60px 0px"
			position="relative"
			cells-number-total="4"
			display="none"
		>
			<Override slot="Content" grid-template-columns="1fr 1fr" grid-gap="24px" lg-grid-template-columns="1fr">
				<Override slot="Cell 0" grid-column="1 / span 2" lg-grid-column="auto / auto" />
				<Override slot="cell-0">
					<Text
						margin="0px 0px 6px 0px"
						color="--darkL1"
						font="--headline1"
						md-text-align="center"
						sm-font="normal 800 30px/1.4 &quot;Montserrat&quot;, sans-serif"
					>
						Тарифы
					</Text>
					<Text
						margin="0px 0px 24px 0px"
						color="--dark"
						font="--decsr"
						lg-font="normal 500 16px/180% &quot;Montserrat&quot;, sans-serif"
						md-text-align="center"
					>
						Для реализации полноценного интернет-магазина и веб-бота в Телеграм у нас представлен один тариф "
						<Strong>
							Магазин
						</Strong>
						"
					</Text>
				</Override>
				<Override slot="cell-1">
					<Box
						min-width="100px"
						min-height="100px"
						border-width="2px"
						border-style="solid"
						border-color="--color-primary"
						padding="48px 48px 48px 48px"
						border-radius="32px"
						display="flex"
						flex-direction="column"
						align-items="flex-start"
						background="--white"
						sm-padding="24px 24px 24px 24px"
					>
						<Text
							margin="0px 0px 8px 0px"
							color="--dark"
							font="--headline1"
							nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
							lg-font="normal 800 24px/1.4 &quot;Montserrat&quot;, sans-serif"
						>
							$9.99
							<Span
								color="--greyD1"
								font="--base"
								overflow-wrap="normal"
								word-break="normal"
								white-space="normal"
								text-indent="0"
								text-overflow="clip"
								hyphens="manual"
								user-select="auto"
								pointer-events="auto"
							>
								{" "}/ в месяц
							</Span>
						</Text>
						<Text margin="0px 0px 16px 0px" color="--dark" font="normal 700 20px/180% --fontFamily-googleMontserrat" lg-font="normal 700 16px/180% --fontFamily-googleMontserrat">
							При оплате за


месяц
						</Text>
						<Text margin="0px 0px 16px 0px" color="--dark" font="--base" sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif">
							У нас единственный тариф в котором доступен абсолютно весь функционал магазина вместе с Веб-ботом
						</Text>
						<Box display="flex" align-items="center" grid-gap="16px" margin="0px 0px 16px 0px">
							<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16:15:36.720Z" display="block" srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=3200 3200w" sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw" />
							<Text margin="0px 0px 0px 3px" font="--base">
								Продажа цифровых товаров
							</Text>
						</Box>
						<Box display="flex" align-items="center" grid-gap="16px" margin="0px 0px 16px 0px">
							<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16:15:36.720Z" display="block" srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=3200 3200w" sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw" />
							<Text margin="0px 0px 0px 3px" font="--base">
								Импорт товаров с Excel, 1C и пр.{" "}
							</Text>
						</Box>
						<Box display="flex" align-items="center" grid-gap="16px" margin="0px 0px 16px 0px">
							<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16:15:36.720Z" display="block" srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=3200 3200w" sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw" />
							<Text margin="0px 0px 0px 3px" font="--base">
								Интеграция платежных систем{" "}
							</Text>
						</Box>
						<Box display="flex" align-items="center" grid-gap="16px" margin="0px 0px 40px 0px">
							<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16:15:36.720Z" display="block" srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/doneblue.png?v=2022-07-20T16%3A15%3A36.720Z&quality=85&w=3200 3200w" sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw" />
							<Text margin="0px 0px 0px 3px" font="--base">
								Рассылка внутри бота
							</Text>
						</Box>
						<Link
							href="https://t.me/uShopWebBot?start=web"
							color="--white"
							font="--button"
							text-decoration-line="initial"
							padding="16px 24px 16px 24px"
							background="--primary"
							border-radius="50px"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--white"
							hover-background="--dark"
							target="_blank"
						>
							15 дней бесплатно
						</Link>
					</Box>
				</Override>
				<Override slot="cell-2">
					<Box
						border-width="2px"
						border-style="solid"
						border-color="--color-white"
						padding="48px 48px 48px 48px"
						border-radius="32px"
						display="flex"
						flex-direction="column"
						background="--white"
						align-items="flex-start"
						height="100%"
						justify-content="space-between"
						sm-padding="24px 24px 24px 24px"
					>
						<Box>
							<Text
								margin="0px 0px 8px 0px"
								color="--red"
								font="--headline1"
								nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
								lg-font="normal 800 24px/1.4 &quot;Montserrat&quot;, sans-serif"
							>
								$7.99{" "}
								<Span
									color="--greyD1"
									text-decoration-line="line-through"
									overflow-wrap="normal"
									word-break="normal"
									white-space="normal"
									text-indent="0"
									text-overflow="clip"
									hyphens="manual"
									user-select="auto"
									pointer-events="auto"
								>
									$9.99
								</Span>
								<Span
									color="--greyD1"
									font="--base"
									overflow-wrap="normal"
									word-break="normal"
									white-space="normal"
									text-indent="0"
									text-overflow="clip"
									hyphens="manual"
									user-select="auto"
									pointer-events="auto"
								>
									{" "}/ в месяц
								</Span>
							</Text>
							<Text margin="0px 0px 16px 0px" color="--dark" font="normal 700 20px/180% --fontFamily-googleMontserrat" lg-font="normal 700 16px/180% --fontFamily-googleMontserrat">
								При оплате сразу за год{" "}
								<Span color="--red">
									скидка 20%
								</Span>
							</Text>
							<Text
								margin="0px 0px 50px 0px"
								color="--dark"
								font="--base"
								nout-margin="0px 0px 20px 0px"
								lg-margin="0px 0px 30px 0px"
								sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif"
							>
								У нас единственный тариф в котором доступен абсолютно весь функционал магазина вместе с Веб-ботом
							</Text>
							<Box display="flex" align-items="center" grid-gap="16px" margin="0px 0px 16px 0px">
								<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/darkdone.svg?v=2022-07-20T16:19:02.924Z" display="block" />
								<Text margin="0px 0px 0px 3px" font="--base">
									Бесплатный домен для сайта, вида site.ru
								</Text>
							</Box>
							<Box
								display="flex"
								align-items="center"
								grid-gap="16px"
								margin="0px 0px 16px 0px"
								lg-margin="0px 0px 40px 0px"
							>
								<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/darkdone.svg?v=2022-07-20T16:19:02.924Z" display="block" />
								<Text margin="0px 0px 0px 3px" font="--base">
									И такие же преимущества, что и при оплате за месяц
								</Text>
							</Box>
						</Box>
						<Link
							href="https://t.me/uShopWebBot?start=web"
							color="--white"
							font="--button"
							text-decoration-line="initial"
							padding="16px 24px 16px 24px"
							border-radius="50px"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--white"
							hover-background="--primary"
							target="_blank"
							background="--dark"
						>
							Создать бот-магазин
						</Link>
					</Box>
				</Override>
				<Override slot="Cell 0th" border-radius="32px" lg-grid-column="auto / auto" />
				<Override slot="Cell 3" grid-column="1 / span 2" />
				<Override slot="cell-3">
					<Box
						border-width="2px"
						border-style="solid"
						border-color="--color-white"
						padding="48px 48px 48px 48px"
						border-radius="32px"
						display="flex"
						flex-direction="column"
						background="--primary"
						align-items="flex-start"
						height="100%"
						justify-content="space-between"
						sm-padding="24px 24px 24px 24px"
					>
						<Text
							margin="0px 0px 8px 0px"
							color="--white"
							font="--headline2"
							nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
							lg-font="normal 800 24px/1.4 &quot;Montserrat&quot;, sans-serif"
						>
							3000 руб.{" "}
							<Span
								color="--white"
								font="--base"
								overflow-wrap="normal"
								word-break="normal"
								white-space="normal"
								text-indent="0"
								text-overflow="clip"
								hyphens="manual"
								user-select="auto"
								pointer-events="auto"
								sm-font="normal 500 0px/160% &quot;Montserrat&quot;, sans-serif"
							>
								{" "}/ срок создания в среднем 5 дней
							</Span>
						</Text>
						<Text margin="0px 0px 16px 0px" color="--white" font="normal 700 20px/180% --fontFamily-googleMontserrat" lg-font="normal 700 16px/180% --fontFamily-googleMontserrat">
							Магазин под ключ
						</Text>
						<Box>
							<Text margin="0px 0px 16px 0px" color="--white" font="--base" sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif">
								Сделаем бот-магазин за вас!
							</Text>
						</Box>
						<Box>
							<Text margin="0px 0px 24px 0px" color="--white" font="--base" sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif">
								Если у вас нет времени заниматься созданием и оформление бота (добавлять товар, настраивать импорт, подключать онлайн оплату и интегрировать службы доставки), то вы можете заказать у нас услугу под ключ
							</Text>
						</Box>
						<Link
							href="https://bot.divly.pro/?utm_source=ucozbotmain&utm_medium=banner&utm_content=tarif"
							color="--dark"
							font="--button"
							text-decoration-line="initial"
							padding="16px 24px 16px 24px"
							border-radius="50px"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--white"
							hover-background="--dark"
							target="_blank"
							background="--background"
						>
							Заказать магазин под ключ
						</Link>
					</Box>
				</Override>
			</Override>
		</Structure>
		<Section
			id="example"
			padding="60px 0 120px 0"
			background="--white"
			position="relative"
			md-padding="60px 0 60px 0"
			sm-padding="30px 0 60px 0"
		>
			<Override
				slot="SectionContent"
				width="90%"
				max-width="none"
				align-items="center"
				padding="90px 30px 90px 30px"
				background="--background"
				border-radius="32px"
				md-padding="40px 20px 40px 20px"
			/>
			<Box max-width="1280px" width="100%">
				<Text
					margin="0px 0px 6px 0px"
					color="--darkL1"
					font="--headline1"
					md-text-align="center"
					sm-font="normal 800 30px/1.4 &quot;Montserrat&quot;, sans-serif"
				>
					Кейсы
				</Text>
				<Text
					margin="0px 0px 48px 0px"
					color="--dark"
					font="--decsr"
					lg-font="normal 500 16px/180% &quot;Montserrat&quot;, sans-serif"
					md-text-align="center"
				>
					Примеры созданных интернет-магазинов в нашем конструкторе в качестве демонстрации:{" "}
				</Text>
				<Box
					min-width="100px"
					min-height="100px"
					display="grid"
					position="relative"
					grid-gap="24px"
					grid-template-columns="repeat(3, 1fr)"
					nout-grid-template-columns="repeat(2, 1fr)"
					md-grid-template-columns="1fr"
				>
					<Components.Knopka
						display="flex"
						transition="-webkit-transition: all .3s;  transition: all .3s"
						border-radius="32px"
						lg-padding="68px 36px 30px 36px"
						background="linear-gradient(180deg,rgba(0, 0, 0, 0) 37.1%,rgba(0, 0, 0, 0.6) 100%),#FFB300"
						flex-direction="column"
						justify-content="flex-end"
						padding="45px 45px 0px 45px"
						min-height="368px"
						align-items="center"
						nout-position="relative"
						position="relative"
						overflow-y="hidden"
						overflow-x="hidden"
					>
						<Override slot="Before image :default" display="none" />
						<Override
							slot="Link :default"
							text-decoration-line="initial"
							color="rgba(0, 0, 238, 0)"
							width="48px"
							height="48px"
						/>
						<Override
							slot="Link :hover"
							display="flex"
							transform="translateY(-30px)"
							width="auto"
							align-items="center"
							justify-content="center"
							background="--primary"
							text-align="center"
							padding="0px 15px 0px 15px"
						/>
						<Override
							slot="Link"
							display="flex"
							align-items="center"
							justify-content="center"
							transition="-webkit-transition: all .3s;  transition: all .3s"
							border-radius="50px"
							font="600 18px --fontFamily-googleInter"
							color="#ffffff"
							text-decoration-line="initial"
							href="https://t.me/Dolce_Bot"
							target="_blank"
						/>
						<Override
							slot="Before Text2"
							font="--decsr"
							margin="0px 0px 0px 0px"
							transition="-webkit-transition: all .5s;  transition: all .5s"
							text-align="center"
							background="rgba(0, 0, 0, 0.59)"
							padding="3px 8px 3px 8px"
							border-radius="6px"
						>
							Доставка еды
						</Override>
						<Override slot="Before Text2 :default">
							Доставка еды
						</Override>
						<Override slot="Before Text2 :hover" transform="translateY(-50px)" />
						<Override
							slot="Before image"
							width="7px"
							height="12px"
							min-width="none"
							min-height="none"
							src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/arrowffuuu.svg?v=2022-07-26T12:39:38.571Z"
							display="none"
						/>
						<Override slot="Before Text3 :default" display="none" />
						<Override slot="Before Text3" margin="16px 0px 16px 0px" font="--button" />
						<Image
							src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black1-min.png?v=2023-08-04T11:09:18.516Z"
							display="block"
							position="absolute"
							bottom="-30px"
							md-min-width="220px"
							sm-width="80%"
							srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black1-min.png?v=2023-08-04T11%3A09%3A18.516Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black1-min.png?v=2023-08-04T11%3A09%3A18.516Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black1-min.png?v=2023-08-04T11%3A09%3A18.516Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black1-min.png?v=2023-08-04T11%3A09%3A18.516Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black1-min.png?v=2023-08-04T11%3A09%3A18.516Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black1-min.png?v=2023-08-04T11%3A09%3A18.516Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black1-min.png?v=2023-08-04T11%3A09%3A18.516Z&quality=85&w=3200 3200w"
							sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
						/>
					</Components.Knopka>
					<Components.Knopka
						display="flex"
						transition="-webkit-transition: all .3s;  transition: all .3s"
						border-radius="32px"
						lg-padding="68px 36px 30px 36px"
						background="linear-gradient(45deg, #4A879A 0%, #C5EDF5 100%)"
						flex-direction="column"
						justify-content="flex-end"
						padding="45px 45px 0px 45px"
						min-height="368px"
						align-items="center"
						nout-position="relative"
						position="relative"
						overflow-y="hidden"
						overflow-x="hidden"
					>
						<Override slot="Before image :default" display="none" />
						<Override
							slot="Link :default"
							text-decoration-line="initial"
							color="rgba(0, 0, 238, 0)"
							width="48px"
							height="48px"
						/>
						<Override
							slot="Link :hover"
							display="flex"
							transform="translateY(-30px)"
							width="auto"
							align-items="center"
							justify-content="center"
							background="--primary"
							text-align="center"
							padding="0px 15px 0px 15px"
						/>
						<Override
							slot="Link"
							display="flex"
							align-items="center"
							justify-content="center"
							transition="-webkit-transition: all .3s;  transition: all .3s"
							border-radius="50px"
							font="600 18px --fontFamily-googleInter"
							color="#ffffff"
							text-decoration-line="initial"
							href="https://t.me/SportClothesBot"
							target="_blank"
						/>
						<Override
							slot="Before Text2"
							font="--decsr"
							margin="0px 0px 0px 0px"
							transition="-webkit-transition: all .5s;  transition: all .5s"
							text-align="center"
							background="rgba(0, 0, 0, 0.59)"
							padding="3px 8px 3px 8px"
							border-radius="6px"
						>
							Магазин одежды
						</Override>
						<Override slot="Before Text2 :default">
							Магазин тортиков
						</Override>
						<Override slot="Before Text2 :hover" transform="translateY(-50px)" />
						<Override
							slot="Before image"
							width="7px"
							height="12px"
							min-width="none"
							min-height="none"
							src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/arrowffuuu.svg?v=2022-07-26T12:39:38.571Z"
							display="none"
						/>
						<Override slot="Before Text3 :default" display="none" />
						<Override slot="Before Text3" margin="16px 0px 16px 0px" font="--button" />
						<Image
							src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-21-min.png?v=2023-08-04T11:06:43.824Z"
							display="block"
							position="absolute"
							bottom="-30px"
							md-min-width="220px"
							sm-width="80%"
							srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-21-min.png?v=2023-08-04T11%3A06%3A43.824Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-21-min.png?v=2023-08-04T11%3A06%3A43.824Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-21-min.png?v=2023-08-04T11%3A06%3A43.824Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-21-min.png?v=2023-08-04T11%3A06%3A43.824Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-21-min.png?v=2023-08-04T11%3A06%3A43.824Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-21-min.png?v=2023-08-04T11%3A06%3A43.824Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-21-min.png?v=2023-08-04T11%3A06%3A43.824Z&quality=85&w=3200 3200w"
							sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
						/>
					</Components.Knopka>
					<Components.Knopka
						display="flex"
						transition="-webkit-transition: all .3s;  transition: all .3s"
						border-radius="32px"
						lg-padding="68px 36px 30px 36px"
						background="linear-gradient(180deg,rgba(0, 0, 0, 0) 37.1%,rgba(0, 0, 0, 0.6) 100%),#A173FF"
						flex-direction="column"
						justify-content="flex-end"
						padding="45px 45px 0px 45px"
						min-height="368px"
						align-items="center"
						nout-position="relative"
						position="relative"
						overflow-y="hidden"
						overflow-x="hidden"
					>
						<Override slot="Before image :default" display="none" />
						<Override
							slot="Link :default"
							text-decoration-line="initial"
							color="rgba(0, 0, 238, 0)"
							width="48px"
							height="48px"
						/>
						<Override
							slot="Link :hover"
							display="flex"
							transform="translateY(-30px)"
							width="auto"
							align-items="center"
							justify-content="center"
							text-align="center"
							padding="0px 15px 0px 15px"
							background="--primary"
						/>
						<Override
							slot="Link"
							display="flex"
							align-items="center"
							justify-content="center"
							transition="-webkit-transition: all .3s;  transition: all .3s"
							border-radius="50px"
							font="600 18px --fontFamily-googleInter"
							color="#ffffff"
							text-decoration-line="initial"
							href="https://t.me/CvetovBot"
							target="_blank"
						/>
						<Override
							slot="Before Text2"
							font="--decsr"
							margin="0px 0px 0px 0px"
							transition="-webkit-transition: all .5s;  transition: all .5s"
							text-align="center"
							background="rgba(0, 0, 0, 0.59)"
							padding="3px 8px 3px 8px"
							border-radius="6px"
						>
							Магазин цветов
						</Override>
						<Override slot="Before Text2 :default">
							Магазин тортиков
						</Override>
						<Override slot="Before Text2 :hover" transform="translateY(-50px)" />
						<Override
							slot="Before image"
							width="7px"
							height="12px"
							min-width="none"
							min-height="none"
							src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/arrowffuuu.svg?v=2022-07-26T12:39:38.571Z"
							display="none"
						/>
						<Override slot="Before Text3 :default" display="none" />
						<Override slot="Before Text3" margin="16px 0px 16px 0px" font="--button" />
						<Image
							src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-1-min.png?v=2023-08-04T11:07:34.809Z"
							display="block"
							position="absolute"
							bottom="-30px"
							md-min-width="220px"
							sm-width="80%"
							srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-1-min.png?v=2023-08-04T11%3A07%3A34.809Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-1-min.png?v=2023-08-04T11%3A07%3A34.809Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-1-min.png?v=2023-08-04T11%3A07%3A34.809Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-1-min.png?v=2023-08-04T11%3A07%3A34.809Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-1-min.png?v=2023-08-04T11%3A07%3A34.809Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-1-min.png?v=2023-08-04T11%3A07%3A34.809Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-1-min.png?v=2023-08-04T11%3A07%3A34.809Z&quality=85&w=3200 3200w"
							sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
						/>
					</Components.Knopka>
					<Components.Knopka
						display="flex"
						transition="-webkit-transition: all .3s;  transition: all .3s"
						border-radius="32px"
						lg-padding="68px 36px 30px 36px"
						background="linear-gradient(45deg, #7B6AE0 0%, #FFBB89 100%)"
						flex-direction="column"
						justify-content="flex-end"
						padding="45px 45px 0px 45px"
						min-height="368px"
						align-items="center"
						nout-position="relative"
						position="relative"
						overflow-y="hidden"
						overflow-x="hidden"
					>
						<Override slot="Before image :default" display="none" />
						<Override
							slot="Link :default"
							text-decoration-line="initial"
							color="rgba(0, 0, 238, 0)"
							width="48px"
							height="48px"
						/>
						<Override
							slot="Link :hover"
							display="flex"
							transform="translateY(-30px)"
							width="auto"
							align-items="center"
							justify-content="center"
							background="--primary"
							text-align="center"
							padding="0px 15px 0px 15px"
						/>
						<Override
							slot="Link"
							display="flex"
							align-items="center"
							justify-content="center"
							transition="-webkit-transition: all .3s;  transition: all .3s"
							border-radius="50px"
							font="600 18px --fontFamily-googleInter"
							color="#ffffff"
							text-decoration-line="initial"
							href="https://t.me/DigitalGood_Bot"
							target="_blank"
						/>
						<Override
							slot="Before Text2"
							font="--decsr"
							margin="0px 0px 0px 0px"
							transition="-webkit-transition: all .5s;  transition: all .5s"
							text-align="center"
							background="rgba(0, 0, 0, 0.59)"
							padding="3px 8px 3px 8px"
							border-radius="6px"
						>
							Цифровые товары
						</Override>
						<Override slot="Before Text2 :default">
							Цифровые товары
						</Override>
						<Override slot="Before Text2 :hover" transform="translateY(-50px)" />
						<Override
							slot="Before image"
							width="7px"
							height="12px"
							min-width="none"
							min-height="none"
							src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/arrowffuuu.svg?v=2022-07-26T12:39:38.571Z"
							display="none"
						/>
						<Override slot="Before Text3 :default" display="none" />
						<Override slot="Before Text3" margin="16px 0px 16px 0px" font="--button" />
						<Image
							src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-11-min.png?v=2023-08-04T11:12:17.577Z"
							display="block"
							position="absolute"
							bottom="-30px"
							md-min-width="220px"
							sm-width="80%"
							srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-11-min.png?v=2023-08-04T11%3A12%3A17.577Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-11-min.png?v=2023-08-04T11%3A12%3A17.577Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-11-min.png?v=2023-08-04T11%3A12%3A17.577Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-11-min.png?v=2023-08-04T11%3A12%3A17.577Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-11-min.png?v=2023-08-04T11%3A12%3A17.577Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-11-min.png?v=2023-08-04T11%3A12%3A17.577Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-11-min.png?v=2023-08-04T11%3A12%3A17.577Z&quality=85&w=3200 3200w"
							sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
						/>
					</Components.Knopka>
					<Components.Knopka
						display="flex"
						transition="-webkit-transition: all .3s;  transition: all .3s"
						border-radius="32px"
						lg-padding="68px 36px 30px 36px"
						background="linear-gradient(45deg, #7B6AE0 0%, #FFBB89 100%)"
						flex-direction="column"
						justify-content="flex-end"
						padding="45px 45px 0px 45px"
						min-height="368px"
						align-items="center"
						nout-position="relative"
						position="relative"
						overflow-y="hidden"
						overflow-x="hidden"
					>
						<Override slot="Before image :default" display="none" />
						<Override
							slot="Link :default"
							text-decoration-line="initial"
							color="rgba(0, 0, 238, 0)"
							width="48px"
							height="48px"
						/>
						<Override
							slot="Link :hover"
							display="flex"
							transform="translateY(-30px)"
							width="auto"
							align-items="center"
							justify-content="center"
							background="--primary"
							text-align="center"
							padding="0px 15px 0px 15px"
						/>
						<Override
							slot="Link"
							display="flex"
							align-items="center"
							justify-content="center"
							transition="-webkit-transition: all .3s;  transition: all .3s"
							border-radius="50px"
							font="600 18px --fontFamily-googleInter"
							color="#ffffff"
							text-decoration-line="initial"
							href="https://t.me/uSportClothes"
							target="_blank"
						/>
						<Override
							slot="Before Text2"
							font="--decsr"
							margin="0px 0px 0px 0px"
							transition="-webkit-transition: all .5s;  transition: all .5s"
							text-align="center"
							background="rgba(0, 0, 0, 0.59)"
							padding="3px 8px 3px 8px"
							border-radius="6px"
						>
							Канал одежды
						</Override>
						<Override slot="Before Text2 :default">
							Канал одежды
						</Override>
						<Override slot="Before Text2 :hover" transform="translateY(-50px)" />
						<Override
							slot="Before image"
							width="7px"
							height="12px"
							min-width="none"
							min-height="none"
							src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/arrowffuuu.svg?v=2022-07-26T12:39:38.571Z"
							display="none"
						/>
						<Override slot="Before Text3 :default" display="none" />
						<Override slot="Before Text3" margin="16px 0px 16px 0px" font="--button" />
						<Image
							src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-2-min.png?v=2023-08-04T11:13:18.651Z"
							display="block"
							position="absolute"
							bottom="-30px"
							md-min-width="220px"
							sm-width="80%"
							srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-2-min.png?v=2023-08-04T11%3A13%3A18.651Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-2-min.png?v=2023-08-04T11%3A13%3A18.651Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-2-min.png?v=2023-08-04T11%3A13%3A18.651Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-2-min.png?v=2023-08-04T11%3A13%3A18.651Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-2-min.png?v=2023-08-04T11%3A13%3A18.651Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-2-min.png?v=2023-08-04T11%3A13%3A18.651Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-2-min.png?v=2023-08-04T11%3A13%3A18.651Z&quality=85&w=3200 3200w"
							sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
						/>
					</Components.Knopka>
					<Components.Knopka
						display="flex"
						transition="-webkit-transition: all .3s;  transition: all .3s"
						border-radius="32px"
						lg-padding="68px 36px 30px 36px"
						background="linear-gradient(180deg,rgba(0, 0, 0, 0) 37.1%,rgba(0, 0, 0, 0.6) 100%),#FA89DE"
						flex-direction="column"
						justify-content="flex-end"
						padding="45px 45px 0px 45px"
						min-height="368px"
						align-items="center"
						nout-position="relative"
						position="relative"
						overflow-y="hidden"
						overflow-x="hidden"
					>
						<Override slot="Before image :default" display="none" />
						<Override
							slot="Link :default"
							text-decoration-line="initial"
							color="rgba(0, 0, 238, 0)"
							width="48px"
							height="48px"
						/>
						<Override
							slot="Link :hover"
							display="flex"
							transform="translateY(-30px)"
							width="auto"
							align-items="center"
							justify-content="center"
							background="--primary"
							text-align="center"
							padding="0px 15px 0px 15px"
						/>
						<Override
							slot="Link"
							display="flex"
							align-items="center"
							justify-content="center"
							transition="-webkit-transition: all .3s;  transition: all .3s"
							border-radius="50px"
							color="#ffffff"
							text-decoration-line="initial"
							href="https://t.me/uShopTelegramBot"
							target="_blank"
						/>
						<Override
							slot="Before Text2"
							font="--decsr"
							margin="0px 0px 0px 0px"
							transition="-webkit-transition: all .5s;  transition: all .5s"
							text-align="center"
							background="rgba(0, 0, 0, 0.59)"
							padding="3px 8px 3px 8px"
							border-radius="6px"
						>
							Магазин тортиков
						</Override>
						<Override slot="Before Text2 :default">
							Магазин тортиков
						</Override>
						<Override slot="Before Text2 :hover" transform="translateY(-50px)" />
						<Override
							slot="Before image"
							width="7px"
							height="12px"
							min-width="none"
							min-height="none"
							src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/arrowffuuu.svg?v=2022-07-26T12:39:38.571Z"
							display="none"
						/>
						<Override slot="Before Text3 :default" display="none" />
						<Override slot="Before Text3" margin="16px 0px 16px 0px" font="--button" />
						<Image
							src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-min.png?v=2023-08-04T11:08:09.146Z"
							display="block"
							position="absolute"
							bottom="-30px"
							md-min-width="220px"
							sm-width="80%"
							srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-min.png?v=2023-08-04T11%3A08%3A09.146Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-min.png?v=2023-08-04T11%3A08%3A09.146Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-min.png?v=2023-08-04T11%3A08%3A09.146Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-min.png?v=2023-08-04T11%3A08%3A09.146Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-min.png?v=2023-08-04T11%3A08%3A09.146Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-min.png?v=2023-08-04T11%3A08%3A09.146Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/iphone-12--black-min.png?v=2023-08-04T11%3A08%3A09.146Z&quality=85&w=3200 3200w"
							sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
						/>
					</Components.Knopka>
				</Box>
			</Box>
			<Link
				href="https://t.me/uShopWeb/28"
				color="--white"
				font="--button"
				text-decoration-line="initial"
				padding="20px 24px 20px 24px"
				border-radius="50px"
				transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
				hover-color="--white"
				hover-background="--dark"
				background="--primary"
				sm-text-align="center"
				margin="40px 0px 0px 0px"
				target="_blank"
			>
				Магазины наших клиентов
			</Link>
		</Section>
		<Structure
			id="webbot"
			padding="80px 0px 80px 0px"
			cells-number-total="8"
			quarkly-title="Content"
			nout-padding="60px 0px 60px 0px"
			position="relative"
			sm-padding="30px 0px 60px 0px"
			background="--primary"
		>
			<Override
				slot="Content"
				grid-template-columns="repeat(3, 1fr)"
				grid-gap="24px"
				nout-grid-template-columns="repeat(2, 1fr)"
				sm-overflow-x="hidden"
				sm-overflow-y="hidden"
				md-grid-template-columns="1fr"
			>
				<Override slot="Cell 0th" align-items="center" justify-content="center" md-grid-column="auto / auto" />
				<Override slot="Cell 0" grid-column="1 /span 3" nout-grid-column="1 / span 2" />
				<Override slot="cell-0">
					<Text
						margin="0px 0px 10px 0px"
						color="--white"
						font="--headline1"
						lg-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
						md-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
						sm-text-align="center"
						md-text-align="center"
						sm-font="normal 800 30px/1.4 &quot;Montserrat&quot;, sans-serif"
					>
						Интересные статьи
					</Text>
				</Override>
				<Override slot="cell-1">
					<Box
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						min-height="540px"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/seobotatop.jpg?v=2025-02-21T22:10:38.424Z"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/seobotatop.jpg?v=2025-02-21T22%3A10%3A38.424Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/seobotatop.jpg?v=2025-02-21T22%3A10%3A38.424Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/seobotatop.jpg?v=2025-02-21T22%3A10%3A38.424Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/seobotatop.jpg?v=2025-02-21T22%3A10%3A38.424Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/seobotatop.jpg?v=2025-02-21T22%3A10%3A38.424Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/seobotatop.jpg?v=2025-02-21T22%3A10%3A38.424Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/seobotatop.jpg?v=2025-02-21T22%3A10%3A38.424Z&quality=85&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Продвижение интернет-магазина
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Статья о том как правильно и какими способами продвигать магазин в формате Телеграм-бота
								</Text>
							</Box>
						</Box>
						<Link
							href="/bot/prodvizhenie-internet-magazina-v-telegram/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="cell-2">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/nadolimagaz.jpg?v=2025-02-21T22:11:03.542Z"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/nadolimagaz.jpg?v=2025-02-21T22%3A11%3A03.542Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/nadolimagaz.jpg?v=2025-02-21T22%3A11%3A03.542Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/nadolimagaz.jpg?v=2025-02-21T22%3A11%3A03.542Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/nadolimagaz.jpg?v=2025-02-21T22%3A11%3A03.542Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/nadolimagaz.jpg?v=2025-02-21T22%3A11%3A03.542Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/nadolimagaz.jpg?v=2025-02-21T22%3A11%3A03.542Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/nadolimagaz.jpg?v=2025-02-21T22%3A11%3A03.542Z&quality=85&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Нужен ли магазин в Телеграм?
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Давайте разберемся, а стоит ли создавать магазин в Телеграм и заниматься его продвижением
								</Text>
							</Box>
						</Box>
						<Link
							href="/bot/dlya-chego-sozdat-magazin-v-telegram/"
							color="--white"
							text-align="center"
							padding="18px 16px 18px 16px"
							text-decoration-line="initial"
							background="--dark"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="cell-3">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22:40:45.741Z"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Размещаем на любом канале продажу товара
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Показываем как возможно размещать товары на продажу не только в боте, но и в Телеграм каналах
								</Text>
							</Box>
						</Box>
						<Link
							href="/bot/onlayn-prodazha-tovarov-na-kanalakh-i-gruppakh/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="Cell 3" sm-display="flex" sm-align-items="center" sm-justify-content="center" />
				<Override slot="cell-4">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/elektrotovarprodazh.jpg?v=2025-02-21T22:11:39.606Z"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/elektrotovarprodazh.jpg?v=2025-02-21T22%3A11%3A39.606Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/elektrotovarprodazh.jpg?v=2025-02-21T22%3A11%3A39.606Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/elektrotovarprodazh.jpg?v=2025-02-21T22%3A11%3A39.606Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/elektrotovarprodazh.jpg?v=2025-02-21T22%3A11%3A39.606Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/elektrotovarprodazh.jpg?v=2025-02-21T22%3A11%3A39.606Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/elektrotovarprodazh.jpg?v=2025-02-21T22%3A11%3A39.606Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/elektrotovarprodazh.jpg?v=2025-02-21T22%3A11%3A39.606Z&quality=85&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Продажа электронных товаров в боте
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									В Телеграм боте в который вы создадите возможно продавать не только физические товары, но и цифровые (файлы, коды, курсы и пр.)
								</Text>
							</Box>
						</Box>
						<Link
							href="/bot/prodazha-elektronnykh-tovarov-v-telegram/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="cell-5">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box
							min-height="540px"
							background="--white"
							border-radius="32px"
							padding="0px 0px 0px 0px"
							overflow-x="hidden"
							overflow-y="hidden"
							display="flex"
							flex-direction="column"
							justify-content="space-between"
							transition="--transformOut"
							hover-transform="translateY(-5px)"
						>
							<Box min-width="100px" min-height="100px">
								<Image
									src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/perenosglav.jpg?v=2025-02-21T22:26:53.854Z"
									display="block"
									width="100%"
									max-height="223px"
									margin="0px 0px 14px 0px"
									object-fit="cover"
									srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/perenosglav.jpg?v=2025-02-21T22%3A26%3A53.854Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/perenosglav.jpg?v=2025-02-21T22%3A26%3A53.854Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/perenosglav.jpg?v=2025-02-21T22%3A26%3A53.854Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/perenosglav.jpg?v=2025-02-21T22%3A26%3A53.854Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/perenosglav.jpg?v=2025-02-21T22%3A26%3A53.854Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/perenosglav.jpg?v=2025-02-21T22%3A26%3A53.854Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/perenosglav.jpg?v=2025-02-21T22%3A26%3A53.854Z&quality=85&w=3200 3200w"
									sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
								/>
								<Box>
									<Text
										color="--dark"
										font="--headline2"
										margin="0px 20px 16px 20px"
										md-text-align="center"
										as="h3"
									>
										Перенос бота клиенту или передача прав
									</Text>
									<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
										Как полностью сменить владельца у бота или сделать частичную передачу прав на управление бота
									</Text>
								</Box>
							</Box>
							<Link
								href="/bot/prava-na-bot-magazin/"
								color="--white"
								padding="18px 16px 18px 16px"
								text-align="center"
								background="--dark"
								text-decoration-line="initial"
								font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
								transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
								hover-color="--primary"
								hover-background="--white"
								target="_blank"
							>
								Читать далее
							</Link>
						</Box>
					</Box>
				</Override>
				<Override slot="cell-6">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/uvedomlenie.jpg?v=2025-02-21T22:12:08.312Z"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/uvedomlenie.jpg?v=2025-02-21T22%3A12%3A08.312Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/uvedomlenie.jpg?v=2025-02-21T22%3A12%3A08.312Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/uvedomlenie.jpg?v=2025-02-21T22%3A12%3A08.312Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/uvedomlenie.jpg?v=2025-02-21T22%3A12%3A08.312Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/uvedomlenie.jpg?v=2025-02-21T22%3A12%3A08.312Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/uvedomlenie.jpg?v=2025-02-21T22%3A12%3A08.312Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/uvedomlenie.jpg?v=2025-02-21T22%3A12%3A08.312Z&quality=85&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Уведомления о новых заказах в Телеграм
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Получаем уведомления в Телеграм о заказах с интернет-магазина{" "}
								</Text>
							</Box>
						</Box>
						<Link
							href="/bot/uvedomleniya-o-zakazakh-v-magazine-v-telegram/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="Cell 7" grid-column="1 / span 3" display="flex" nout-grid-column="1 / span 2" />
				<Override slot="cell-7">
					<Link
						href="/bot/instrukciya/"
						color="--white"
						font="--button"
						text-decoration-line="initial"
						padding="20px 24px 20px 24px"
						border-radius="50px"
						transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
						hover-color="--dark"
						hover-background="--white"
						background="--dark"
						sm-text-align="center"
						margin="20px 0px 0px 0px"
					>
						Пошаговая инструкция по созданию бота
					</Link>
				</Override>
			</Override>
		</Structure>
		<Section
			id="faq"
			padding="60px 0 90px 0"
			background="--white"
			position="relative"
			md-padding="60px 0 60px 0"
			sm-padding="30px 0 60px 0"
		>
			<Override
				slot="SectionContent"
				width="90%"
				max-width="1320px"
				align-items="center"
				padding="60px 30px 60px 30px"
				background="--background"
				border-radius="32px"
				md-padding="40px 20px 40px 20px"
				sm-width="95%"
			/>
			<Box max-width="1280px" width="100%">
				<Text
					margin="0px 0px 36px 0px"
					color="--darkL1"
					font="--headline1"
					md-text-align="center"
					sm-font="normal 800 30px/1.4 &quot;Montserrat&quot;, sans-serif"
					lg-text-align="center"
					lg-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
				>
					FAQ - Часто задаваемые вопросы
				</Text>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						lg-width="100%"
						lg-text-align="center"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						Чем наш сервис отличается от других сервисов?
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						/>
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						Мы являемся первым конструктором веб-ботов в направлении E-commerce, у нас вы можете самостоятельно создать телеграм-магазин буквально за 10 минут. У нас нет лишних функций, а интерфейс интуитивно понятен каждому. Просто создайте бота в Botfather, подключите его к нашему конструктору, загрузите товары и начните продавать в Telegram.
					</Text>
				</Components.QuarklycommunityKitCollapse>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						lg-width="100%"
						lg-text-align="center"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						Какие возможности кроме продаж в Telegram есть у бота?
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						Помимо продажи товара и приема онлайн платежей, бот может делать следующее:
					</Text>
					<List
						margin="0px 0px 0px 0px"
						padding="0px 0px 0px 20px"
						list-style-type="disc"
						as="ul"
						font="--base"
					>
						<Text margin="0px 0px 0px 0px">
							Делать рассылки на всех пользователей которые запустили вашего бота, например вы можете оповестить о каких-либо скидках или акциях на товар;
						</Text>
						<Text margin="0px 0px 0px 0px">
							Создавать промо-коды;
						</Text>
						<Text margin="0px 0px 0px 0px">
							Создать дополнительную кнопку в меню бота и разместить там ваши контакты;
						</Text>
						<Text margin="0px 0px 0px 0px">
							Просматривать статистику вашего бота;
						</Text>
						<Text margin="0px 0px 0px 0px">
							Получать уведомления о новых заказах прямо в боте;
						</Text>
						<Text margin="0px 0px 0px 0px">
							А также помимо бота, вы  создаете полноценный интернет-магазин, со всем необходимым функционалом, который также входит в один тариф.
						</Text>
					</List>
				</Components.QuarklycommunityKitCollapse>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						lg-width="100%"
						lg-text-align="center"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						Какие платежные системы и валюты доступны в боте?
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						В боте возможно подключить платёжные сервисы с возможностью принимать оплату в{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Рублях
						</Em>
						,{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Гривнах
						</Em>
						,{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Тенге
						</Em>
						,{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Сум
						</Em>
						,{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Долларах
						</Em>
						,{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Евро
						</Em>
						,{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Фунтах{" "}
						</Em>
						и в других 77 валютах оставаясь в диалоге с ботом.
						<br />
						<br />
						Платежные системы которые доступны внутри Telegram:{" "}
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							ЮКасса (Яндекс.Касса), Сбербанк, Tranzzo (Interkassa), Stripe, Paycom.Uz / Payme, CLICK Uzbekistan, Rave by Flutterwave,
						</Strong>
						{" "}
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							LiqPay, Smart Glocal, Unlimint, Paykassma, PSB, Bank 131, LeoGaming, Cascad, Paymega, Portmone, Global Pay UZ, iPay88, ECOMMPAY
						</Strong>
						{" "}и{" "}
						<Span
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							<Strong
								overflow-wrap="normal"
								word-break="normal"
								white-space="normal"
								text-indent="0"
								text-overflow="clip"
								hyphens="manual"
								user-select="auto"
								pointer-events="auto"
							>
								PayMaster.
							</Strong>
							<br />
							<br />
							<Strong
								overflow-wrap="normal"
								word-break="normal"
								white-space="normal"
								text-indent="0"
								text-overflow="clip"
								hyphens="manual"
								user-select="auto"
								pointer-events="auto"
							>
								Важно!{" "}
							</Strong>
							Если вы не зарегистрированы в качестве Юридического лица (ИП, ООО и так далее), то вам подойдут: ЮМани (Яндекс.Деньги), Enot, Wata, AntiloPay, OverPay и CardLink
							<br />
							<br />
							А также можно принимать оплату при помощи криптовалют (USDT, BTC, ETH, TON и пр.) за счет платежного сервиса{" "}
							<Link
								href="/onlayn-oplata-v-telegram-magazine/"
								text-decoration-line="initial"
								color="--primary"
								hover-text-decoration-line="underline"
								overflow-wrap="normal"
								word-break="normal"
								white-space="normal"
								text-indent="0"
								text-overflow="clip"
								hyphens="manual"
								user-select="auto"
								pointer-events="auto"
							>
								CryptoBot
							</Link>
							{" "}и{" "}
							<Link href="/oplata-kriptoi-v-telegram-magazine" color="--primary" text-decoration-line="initial" hover-text-decoration-line="underline">
								xRocket
							</Link>
						</Span>
					</Text>
				</Components.QuarklycommunityKitCollapse>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						lg-width="100%"
						lg-text-align="center"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						Что будет, когда срок действия демо-тарифа закончится?
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						При первичном создании мы предоставляем 15 дней пробного периода для сайта и веб-бота, на основе этих дней, вы можете полноценно оценить функционал бота. 
После завершения пробного периода функционал бота будет отключен до оплаты тарифа "
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Магазин
						</Strong>
						" или выше.
					</Text>
				</Components.QuarklycommunityKitCollapse>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					lg-width="100%"
					lg-text-align="center"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						Можно ли оплатить тариф по договору?
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						Если вы представляете юридическое лицо и хотите с помощью безналичного перевода оплатить какую-либо конкретную услугу или пополнить лицевой счет сайта, то вы можете выставить счет в панели управления:{" "}
						<Link
							href="https://www.ucoz.ru/help/pro/kak-oplatit-i-ubrat-reklamu#cashless_payment"
							text-decoration-line="initial"
							color="--primary"
							target="_blank"
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							инструкция
							<br />
							<br />
						</Link>
						Помимо этого оплатить тариф вы можете при помощи: Любой банковской карты, ЮMoney, PayPal, SMS, WebMoney.
					</Text>
				</Components.QuarklycommunityKitCollapse>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						sm-width="100%"
						lg-width="100%"
						lg-text-align="center"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						Как сделать категории в боте?
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						Чтобы создать, изменить или удалить категорию, в панели управления выберите раздел “Интернет-магазин” и перейдите в “Управление категориями”:{" "}
						<Link
							href="https://www.ucoz.ru/help/online-shop/panel-upravleniya-kategoriyami"
							color="--primary"
							text-decoration-line="initial"
							target="_blank"
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							инструкция
						</Link>
					</Text>
				</Components.QuarklycommunityKitCollapse>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						lg-width="100%"
						lg-text-align="center"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						Можно ли чтобы веб-бота сделали за меня?
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						Да, вы можете заказать разработку в  нашей официальной веб-студии DIvly:{" "}
						<Link href="https://bot.divly.pro/" target="_blank" color="--primary" text-decoration-line="initial">
							https://bot.divly.pro/
						</Link>
					</Text>
				</Components.QuarklycommunityKitCollapse>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						lg-width="100%"
						lg-text-align="center"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						Куда обращаться, когда возникают вопросы?
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						Все вопросы вы можете задавать внутри Телеграм через нашего бота:{" "}
						<Link href="https://t.me/uShopHelpBot" color="--primary" text-decoration-line="initial" target="_blank">
							@uShopHelpBot
						</Link>
					</Text>
				</Components.QuarklycommunityKitCollapse>
			</Box>
		</Section>
		<Section background="--dark" padding="125px 0 125px 0" nout-padding="60px 0 60px 0" position="relative">
			<Override
				slot="SectionContent"
				display="flex"
				align-items="flex-start"
				md-align-items="center"
				md-justify-content="center"
				md-text-align="center"
			/>
			<Text
				margin="0px 0px 24px 0px"
				color="--white"
				font="--headline1"
				nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
				lg-font="normal 800 26px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-font="normal 800 22px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
				as="h2"
			>
				Создадим магазин в виде бота Телеграм под ключ за 9800₽ за вас!
			</Text>
			<Text
				margin="0px 0px 48px 0px"
				color="--white"
				font="--decsr"
				md-font="normal 500 16px/180% &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif"
			>
				А также оказываем услуги по созданию сайтов, магазинов, порталов и лендингов под ключ. Помощь по сайтам,
				<br />
				SEO-продвижение и консультации с вебмастерами.
			</Text>
			<Link
				href="https://bot.divly.pro/?utm_source=ucozbotmain&utm_medium=banner&utm_content=footer-"
				color="--white"
				font="--button"
				text-decoration-line="initial"
				padding="16px 28px 16px 28px"
				background="--primary"
				border-radius="50px"
				transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
				hover-color="--dark"
				hover-background="--white"
				target="_blank"
			>
				Заказать магазин в Telegram
			</Link>
		</Section>
		<Section
			background="--dark"
			padding="15px 0 15px 0"
			border-style="solid"
			border-color="--color-white"
			border-width="1px 0px 0px 0px"
			position="relative"
			md-padding="15px 0 60px 0"
		>
			<Override
				slot="SectionContent"
				display="flex"
				align-items="center"
				flex-direction="row"
				grid-gap="16px"
				justify-content="space-between"
				md-flex-direction="column"
				md-align-items="center"
			/>
			<Box>
				<Text margin="0px 0px 0px 0px" color="--white" font="--base">
					<Link
						href="https://ukit.group/"
						color="--white"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
						padding="5px 5px 5px 5px"
					>
						© uKit Group
					</Link>
				</Text>
			</Box>
			<Box
				display="flex"
				grid-gap="32px"
				sm-flex-direction="column"
				sm-display="flex"
				sm-grid-gap="8px"
			>
				<Link
					href="https://www.ucoz.ru/terms/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Условия использования
				</Link>
				<Link
					href="https://www.ucoz.ru/details/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Юридическая информация
					<Link href="https://www.ucoz.ru/details/" />
				</Link>
			</Box>
			<LinkBox
				href="https://t.me/uShopWeb"
				target="_blank"
				transition="--opacityOut"
				hover-opacity="0.7"
				color="--primary"
				background="--background"
				border-radius="50%"
			>
				<Icon
					category="fa"
					icon={FaTelegram}
					size="30px"
					padding="1px 1px 1px 1px"
					box-shadow="--xl"
				/>
			</LinkBox>
		</Section>
		<Components.Chat
			left="0px"
			right="1256.5498681640624px"
			width="194.3621318359375px"
			md-width="100%"
			md-min-width="0px"
			md-min-height="0px"
			z-index="1"
			sm-z-index="9"
		>
			<Override slot="icon" md-display="none" />
			<Override
				slot="text"
				md-margin="0px 0px 0px 0px"
				md-width="100%"
				md-border-radius="0px"
				md-text-align="center"
				md-padding="10px 16px 10px 16px"
			/>
			<Override
				slot="linkBox"
				md-margin="0px 0px 0px 0px"
				md-justify-content="center"
				md-align-items="center"
				md-flex-direction="column"
			/>
		</Components.Chat>
		<Components.EmbedHTML />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"62ab65c921e43d0020961284"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n    scroll-behavior: smooth;\n}\nbody {\n    position: relative !important;\n}"}
			</style>
			<script place={"endOfBody"} rawKey={"639c57f598af799c2def4641"}>
				{"   (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n   m[i].l=1*new Date();\n   for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}\n   k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n   (window, document, \"script\", \"https://mc.yandex.ru/metrika/tag.js\", \"ym\");\n\n   ym(91719479, \"init\", {\n        clickmap:true,\n        trackLinks:true,\n        accurateTrackBounce:true,\n        webvisor:true\n   });"}
			</script>
			<script place={"endOfHead"} rawKey={"65b906fcebf1ff7fe82ff95a"}>
				{"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','GTM-59QRNH');"}
			</script>
			<script async={true} src={"//code.jivo.ru/widget/EsmX5tZp4R"} place={"endOfHead"} rawKey={"69b7f73f921c1a779c7c2cc6"} />
		</RawHtml>
	</Theme>;
});